"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModifyEvent = void 0;

var _Collection = _interopRequireDefault(require("../Collection.js"));

var _CollectionEventType = _interopRequireDefault(require("../CollectionEventType.js"));

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _Feature = _interopRequireDefault(require("../Feature.js"));

var _GeometryType = _interopRequireDefault(require("../geom/GeometryType.js"));

var _MapBrowserEventType = _interopRequireDefault(require("../MapBrowserEventType.js"));

var _Point = _interopRequireDefault(require("../geom/Point.js"));

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _RBush = _interopRequireDefault(require("../structs/RBush.js"));

var _VectorEventType = _interopRequireDefault(require("../source/VectorEventType.js"));

var _Vector = _interopRequireDefault(require("../layer/Vector.js"));

var _Vector2 = _interopRequireDefault(require("../source/Vector.js"));

var _condition = require("../events/condition.js");

var _extent = require("../extent.js");

var _coordinate = require("../coordinate.js");

var _Style = require("../style/Style.js");

var _array = require("../array.js");

var _Polygon = require("../geom/Polygon.js");

var _proj = require("../proj.js");

var _util = require("../util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Modify
 */


/**
 * The segment index assigned to a circle's center when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */
var CIRCLE_CENTER_INDEX = 0;
/**
 * The segment index assigned to a circle's circumference when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */

var CIRCLE_CIRCUMFERENCE_INDEX = 1;
var tempExtent = [0, 0, 0, 0];
var tempSegment = [];
/**
 * @enum {string}
 */

var ModifyEventType = {
  /**
   * Triggered upon feature modification start
   * @event ModifyEvent#modifystart
   * @api
   */
  MODIFYSTART: 'modifystart',

  /**
   * Triggered upon feature modification end
   * @event ModifyEvent#modifyend
   * @api
   */
  MODIFYEND: 'modifyend'
};
/**
 * @typedef {Object} SegmentData
 * @property {Array<number>} [depth] Depth.
 * @property {import("../Feature").FeatureLike} feature Feature.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} [index] Index.
 * @property {Array<Array<number>>} segment Segment.
 * @property {Array<SegmentData>} [featureSegments] FeatureSegments.
 */

/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event will be considered to add or move a
 * vertex to the sketch. Default is
 * {@link module:ol/events/condition.primaryAction}.
 * @property {import("../events/condition.js").Condition} [deleteCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. By default,
 * {@link module:ol/events/condition.singleClick} with
 * {@link module:ol/events/condition.altKeyOnly} results in a vertex deletion.
 * @property {import("../events/condition.js").Condition} [insertVertexCondition] A
 * function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether a new vertex should be added to the sketch
 * features. Default is {@link module:ol/events/condition.always}.
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
 * pointer close enough to a segment or vertex for editing.
 * @property {import("../style/Style.js").StyleLike} [style]
 * Style used for the modification point or vertex. For linestrings and polygons, this will
 * be the affected vertex, for circles a point along the circle, and for points the actual
 * point. If not configured, the default edit style is used (see {@link module:ol/style/Style~Style}).
 * When using a style function, the point feature passed to the function will have a `features`
 * property - an array whose entries are the features that are being modified, and a `geometries`
 * property - an array whose entries are the geometries that are being modified. Both arrays are
 * in the same order. The `geometries` are only useful when modifying geometry collections, where
 * the geometry will be the particular geometry from the collection that is being modified.
 * @property {VectorSource} [source] The vector source with
 * features to modify.  If a vector source is not provided, a feature collection
 * must be provided with the `features` option.
 * @property {boolean|import("../layer/BaseVector").default} [hitDetection] When configured, point
 * features will be considered for modification based on their visual appearance, instead of being within
 * the `pixelTolerance` from the pointer location. When a {@link module:ol/layer/BaseVector~BaseVectorLayer} is
 * provided, only the rendered representation of the features on that layer will be considered.
 * @property {Collection<Feature>} [features]
 * The features the interaction works on.  If a feature collection is not
 * provided, a vector source must be provided with the `source` option.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {boolean} [snapToPointer=!hitDetection] The vertex, point or segment being modified snaps to the
 * pointer coordinate when clicked within the `pixelTolerance`.
 */

/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Modify~Modify} instances are
 * instances of this type.
 */

var ModifyEvent =
/** @class */
function (_super) {
  __extends(ModifyEvent, _super);
  /**
   * @param {ModifyEventType} type Type.
   * @param {Collection<import("../Feature").FeatureLike>} features
   * The features modified.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent
   * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */


  function ModifyEvent(type, features, mapBrowserEvent) {
    var _this = _super.call(this, type) || this;
    /**
     * The features being modified.
     * @type {Collection<import("../Feature").FeatureLike>}
     * @api
     */


    _this.features = features;
    /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */

    _this.mapBrowserEvent = mapBrowserEvent;
    return _this;
  }

  return ModifyEvent;
}(_Event["default"]);

exports.ModifyEvent = ModifyEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'modifyend'|'modifystart', ModifyEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'modifyend'|'modifystart', Return>} ModifyOnSignature
 */

/**
 * @classdesc
 * Interaction for modifying feature geometries.  To modify features that have
 * been added to an existing source, construct the modify interaction with the
 * `source` option.  If you want to modify features in a collection (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.  The interaction must be constructed with either a
 * `source` or `features` option.
 *
 * Cartesian distance from the pointer is used to determine the features that
 * will be modified. This means that geometries will only be considered for
 * modification when they are within the configured `pixelTolerance`. For point
 * geometries, the `hitDetection` option can be used to match their visual
 * appearance.
 *
 * By default, the interaction will allow deletion of vertices when the `alt`
 * key is pressed.  To configure the interaction with a different condition
 * for deletion, use the `deleteCondition` option.
 * @fires ModifyEvent
 * @api
 */
var Modify =
/** @class */
function (_super) {
  __extends(Modify, _super);
  /**
   * @param {Options} options Options.
   */


  function Modify(options) {
    var _this = _super.call(this,
    /** @type {import("./Pointer.js").Options} */
    options) || this;
    /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */


    _this.on;
    /***
     * @type {ModifyOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {ModifyOnSignature<void>}
     */

    _this.un;
    /** @private */

    _this.boundHandleFeatureChange_ = _this.handleFeatureChange_.bind(_this);
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.primaryAction;
    /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */

    _this.defaultDeleteCondition_ = function (mapBrowserEvent) {
      return (0, _condition.altKeyOnly)(mapBrowserEvent) && (0, _condition.singleClick)(mapBrowserEvent);
    };
    /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */


    _this.deleteCondition_ = options.deleteCondition ? options.deleteCondition : _this.defaultDeleteCondition_;
    /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */

    _this.insertVertexCondition_ = options.insertVertexCondition ? options.insertVertexCondition : _condition.always;
    /**
     * Editing vertex.
     * @type {Feature<Point>}
     * @private
     */

    _this.vertexFeature_ = null;
    /**
     * Segments intersecting {@link this.vertexFeature_} by segment uid.
     * @type {Object<string, boolean>}
     * @private
     */

    _this.vertexSegments_ = null;
    /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */

    _this.lastPixel_ = [0, 0];
    /**
     * Tracks if the next `singleclick` event should be ignored to prevent
     * accidental deletion right after vertex creation.
     * @type {boolean}
     * @private
     */

    _this.ignoreNextSingleClick_ = false;
    /**
     * @type {Collection<import("../Feature").FeatureLike>}
     * @private
     */

    _this.featuresBeingModified_ = null;
    /**
     * Segment RTree for each layer
     * @type {RBush<SegmentData>}
     * @private
     */

    _this.rBush_ = new _RBush["default"]();
    /**
     * @type {number}
     * @private
     */

    _this.pixelTolerance_ = options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
    /**
     * @type {boolean}
     * @private
     */

    _this.snappedToVertex_ = false;
    /**
     * Indicate whether the interaction is currently changing a feature's
     * coordinates.
     * @type {boolean}
     * @private
     */

    _this.changingFeature_ = false;
    /**
     * @type {Array}
     * @private
     */

    _this.dragSegments_ = [];
    /**
     * Draw overlay where sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */

    _this.overlay_ = new _Vector["default"]({
      source: new _Vector2["default"]({
        useSpatialIndex: false,
        wrapX: !!options.wrapX
      }),
      style: options.style ? options.style : getDefaultStyleFunction(),
      updateWhileAnimating: true,
      updateWhileInteracting: true
    });
    /**
     * @const
     * @private
     * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default): void>}
     */

    _this.SEGMENT_WRITERS_ = {
      'Point': _this.writePointGeometry_.bind(_this),
      'LineString': _this.writeLineStringGeometry_.bind(_this),
      'LinearRing': _this.writeLineStringGeometry_.bind(_this),
      'Polygon': _this.writePolygonGeometry_.bind(_this),
      'MultiPoint': _this.writeMultiPointGeometry_.bind(_this),
      'MultiLineString': _this.writeMultiLineStringGeometry_.bind(_this),
      'MultiPolygon': _this.writeMultiPolygonGeometry_.bind(_this),
      'Circle': _this.writeCircleGeometry_.bind(_this),
      'GeometryCollection': _this.writeGeometryCollectionGeometry_.bind(_this)
    };
    /**
     * @type {VectorSource}
     * @private
     */

    _this.source_ = null;
    /**
     * @type {boolean|import("../layer/BaseVector").default}
     */

    _this.hitDetection_ = null;
    var features;

    if (options.features) {
      features = options.features;
    } else if (options.source) {
      _this.source_ = options.source;
      features = new _Collection["default"](_this.source_.getFeatures());

      _this.source_.addEventListener(_VectorEventType["default"].ADDFEATURE, _this.handleSourceAdd_.bind(_this));

      _this.source_.addEventListener(_VectorEventType["default"].REMOVEFEATURE, _this.handleSourceRemove_.bind(_this));
    }

    if (!features) {
      throw new Error('The modify interaction requires features, a source or a layer');
    }

    if (options.hitDetection) {
      _this.hitDetection_ = options.hitDetection;
    }
    /**
     * @type {Collection<import("../Feature.js").FeatureLike>}
     * @private
     */


    _this.features_ = features;

    _this.features_.forEach(_this.addFeature_.bind(_this));

    _this.features_.addEventListener(_CollectionEventType["default"].ADD, _this.handleFeatureAdd_.bind(_this));

    _this.features_.addEventListener(_CollectionEventType["default"].REMOVE, _this.handleFeatureRemove_.bind(_this));
    /**
     * @type {import("../MapBrowserEvent.js").default}
     * @private
     */


    _this.lastPointerEvent_ = null;
    /**
     * Delta (x, y in map units) between matched rtree vertex and pointer vertex.
     * @type {Array<number>}
     */

    _this.delta_ = [0, 0];
    /**
     * @private
     */

    _this.snapToPointer_ = options.snapToPointer === undefined ? !_this.hitDetection_ : options.snapToPointer;
    return _this;
  }
  /**
   * @param {Feature} feature Feature.
   * @private
   */


  Modify.prototype.addFeature_ = function (feature) {
    var geometry = feature.getGeometry();

    if (geometry) {
      var writer = this.SEGMENT_WRITERS_[geometry.getType()];

      if (writer) {
        writer(feature, geometry);
      }
    }

    var map = this.getMap();

    if (map && map.isRendered() && this.getActive()) {
      this.handlePointerAtPixel_(this.lastPixel_, map);
    }

    feature.addEventListener(_EventType["default"].CHANGE, this.boundHandleFeatureChange_);
  };
  /**
   * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
   * @param {Array<Array<SegmentData>>} segments The segments subject to modification.
   * @private
   */


  Modify.prototype.willModifyFeatures_ = function (evt, segments) {
    if (!this.featuresBeingModified_) {
      this.featuresBeingModified_ = new _Collection["default"]();
      var features = this.featuresBeingModified_.getArray();

      for (var i = 0, ii = segments.length; i < ii; ++i) {
        var segment = segments[i];

        for (var s = 0, ss = segment.length; s < ss; ++s) {
          var feature = segment[s].feature;

          if (feature && features.indexOf(feature) === -1) {
            this.featuresBeingModified_.push(feature);
          }
        }
      }

      if (this.featuresBeingModified_.getLength() === 0) {
        this.featuresBeingModified_ = null;
      } else {
        this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYSTART, this.featuresBeingModified_, evt));
      }
    }
  };
  /**
   * @param {Feature} feature Feature.
   * @private
   */


  Modify.prototype.removeFeature_ = function (feature) {
    this.removeFeatureSegmentData_(feature); // Remove the vertex feature if the collection of candidate features is empty.

    if (this.vertexFeature_ && this.features_.getLength() === 0) {
      this.overlay_.getSource().removeFeature(this.vertexFeature_);
      this.vertexFeature_ = null;
    }

    feature.removeEventListener(_EventType["default"].CHANGE, this.boundHandleFeatureChange_);
  };
  /**
   * @param {Feature} feature Feature.
   * @private
   */


  Modify.prototype.removeFeatureSegmentData_ = function (feature) {
    var rBush = this.rBush_;
    /** @type {Array<SegmentData>} */

    var nodesToRemove = [];
    rBush.forEach(
    /**
     * @param {SegmentData} node RTree node.
     */
    function (node) {
      if (feature === node.feature) {
        nodesToRemove.push(node);
      }
    });

    for (var i = nodesToRemove.length - 1; i >= 0; --i) {
      var nodeToRemove = nodesToRemove[i];

      for (var j = this.dragSegments_.length - 1; j >= 0; --j) {
        if (this.dragSegments_[j][0] === nodeToRemove) {
          this.dragSegments_.splice(j, 1);
        }
      }

      rBush.remove(nodeToRemove);
    }
  };
  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */


  Modify.prototype.setActive = function (active) {
    if (this.vertexFeature_ && !active) {
      this.overlay_.getSource().removeFeature(this.vertexFeature_);
      this.vertexFeature_ = null;
    }

    _super.prototype.setActive.call(this, active);
  };
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */


  Modify.prototype.setMap = function (map) {
    this.overlay_.setMap(map);

    _super.prototype.setMap.call(this, map);
  };
  /**
   * Get the overlay layer that this interaction renders the modification point or vertex to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */


  Modify.prototype.getOverlay = function () {
    return this.overlay_;
  };
  /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */


  Modify.prototype.handleSourceAdd_ = function (event) {
    if (event.feature) {
      this.features_.push(event.feature);
    }
  };
  /**
   * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
   * @private
   */


  Modify.prototype.handleSourceRemove_ = function (event) {
    if (event.feature) {
      this.features_.remove(event.feature);
    }
  };
  /**
   * @param {import("../Collection.js").CollectionEvent} evt Event.
   * @private
   */


  Modify.prototype.handleFeatureAdd_ = function (evt) {
    this.addFeature_(
    /** @type {Feature} */
    evt.element);
  };
  /**
   * @param {import("../events/Event.js").default} evt Event.
   * @private
   */


  Modify.prototype.handleFeatureChange_ = function (evt) {
    if (!this.changingFeature_) {
      var feature =
      /** @type {Feature} */
      evt.target;
      this.removeFeature_(feature);
      this.addFeature_(feature);
    }
  };
  /**
   * @param {import("../Collection.js").CollectionEvent} evt Event.
   * @private
   */


  Modify.prototype.handleFeatureRemove_ = function (evt) {
    var feature =
    /** @type {Feature} */
    evt.element;
    this.removeFeature_(feature);
  };
  /**
   * @param {Feature} feature Feature
   * @param {Point} geometry Geometry.
   * @private
   */


  Modify.prototype.writePointGeometry_ = function (feature, geometry) {
    var coordinates = geometry.getCoordinates();
    /** @type {SegmentData} */

    var segmentData = {
      feature: feature,
      geometry: geometry,
      segment: [coordinates, coordinates]
    };
    this.rBush_.insert(geometry.getExtent(), segmentData);
  };
  /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writeMultiPointGeometry_ = function (feature, geometry) {
    var points = geometry.getCoordinates();

    for (var i = 0, ii = points.length; i < ii; ++i) {
      var coordinates = points[i];
      /** @type {SegmentData} */

      var segmentData = {
        feature: feature,
        geometry: geometry,
        depth: [i],
        index: i,
        segment: [coordinates, coordinates]
      };
      this.rBush_.insert(geometry.getExtent(), segmentData);
    }
  };
  /**
   * @param {Feature} feature Feature
   * @param {import("../geom/LineString.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writeLineStringGeometry_ = function (feature, geometry) {
    var coordinates = geometry.getCoordinates();

    for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
      var segment = coordinates.slice(i, i + 2);
      /** @type {SegmentData} */

      var segmentData = {
        feature: feature,
        geometry: geometry,
        index: i,
        segment: segment
      };
      this.rBush_.insert((0, _extent.boundingExtent)(segment), segmentData);
    }
  };
  /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writeMultiLineStringGeometry_ = function (feature, geometry) {
    var lines = geometry.getCoordinates();

    for (var j = 0, jj = lines.length; j < jj; ++j) {
      var coordinates = lines[j];

      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
        var segment = coordinates.slice(i, i + 2);
        /** @type {SegmentData} */

        var segmentData = {
          feature: feature,
          geometry: geometry,
          depth: [j],
          index: i,
          segment: segment
        };
        this.rBush_.insert((0, _extent.boundingExtent)(segment), segmentData);
      }
    }
  };
  /**
   * @param {Feature} feature Feature
   * @param {import("../geom/Polygon.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writePolygonGeometry_ = function (feature, geometry) {
    var rings = geometry.getCoordinates();

    for (var j = 0, jj = rings.length; j < jj; ++j) {
      var coordinates = rings[j];

      for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
        var segment = coordinates.slice(i, i + 2);
        /** @type {SegmentData} */

        var segmentData = {
          feature: feature,
          geometry: geometry,
          depth: [j],
          index: i,
          segment: segment
        };
        this.rBush_.insert((0, _extent.boundingExtent)(segment), segmentData);
      }
    }
  };
  /**
   * @param {Feature} feature Feature
   * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writeMultiPolygonGeometry_ = function (feature, geometry) {
    var polygons = geometry.getCoordinates();

    for (var k = 0, kk = polygons.length; k < kk; ++k) {
      var rings = polygons[k];

      for (var j = 0, jj = rings.length; j < jj; ++j) {
        var coordinates = rings[j];

        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
          var segment = coordinates.slice(i, i + 2);
          /** @type {SegmentData} */

          var segmentData = {
            feature: feature,
            geometry: geometry,
            depth: [j, k],
            index: i,
            segment: segment
          };
          this.rBush_.insert((0, _extent.boundingExtent)(segment), segmentData);
        }
      }
    }
  };
  /**
   * We convert a circle into two segments.  The segment at index
   * {@link CIRCLE_CENTER_INDEX} is the
   * circle's center (a point).  The segment at index
   * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
   * the circumference, and is not a line segment.
   *
   * @param {Feature} feature Feature.
   * @param {import("../geom/Circle.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writeCircleGeometry_ = function (feature, geometry) {
    var coordinates = geometry.getCenter();
    /** @type {SegmentData} */

    var centerSegmentData = {
      feature: feature,
      geometry: geometry,
      index: CIRCLE_CENTER_INDEX,
      segment: [coordinates, coordinates]
    };
    /** @type {SegmentData} */

    var circumferenceSegmentData = {
      feature: feature,
      geometry: geometry,
      index: CIRCLE_CIRCUMFERENCE_INDEX,
      segment: [coordinates, coordinates]
    };
    var featureSegments = [centerSegmentData, circumferenceSegmentData];
    centerSegmentData.featureSegments = featureSegments;
    circumferenceSegmentData.featureSegments = featureSegments;
    this.rBush_.insert((0, _extent.createOrUpdateFromCoordinate)(coordinates), centerSegmentData);
    var circleGeometry =
    /** @type {import("../geom/Geometry.js").default} */
    geometry;
    var userProjection = (0, _proj.getUserProjection)();

    if (userProjection && this.getMap()) {
      var projection = this.getMap().getView().getProjection();
      circleGeometry = circleGeometry.clone().transform(userProjection, projection);
      circleGeometry = (0, _Polygon.fromCircle)(
      /** @type {import("../geom/Circle.js").default} */
      circleGeometry).transform(projection, userProjection);
    }

    this.rBush_.insert(circleGeometry.getExtent(), circumferenceSegmentData);
  };
  /**
   * @param {Feature} feature Feature
   * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
   * @private
   */


  Modify.prototype.writeGeometryCollectionGeometry_ = function (feature, geometry) {
    var geometries = geometry.getGeometriesArray();

    for (var i = 0; i < geometries.length; ++i) {
      var geometry_1 = geometries[i];
      var writer = this.SEGMENT_WRITERS_[geometry_1.getType()];
      writer(feature, geometry_1);
    }
  };
  /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {Array<import("../Feature").FeatureLike>} features The features being modified.
   * @param {Array<import("../geom/SimpleGeometry.js").default>} geometries The geometries being modified.
   * @return {Feature} Vertex feature.
   * @private
   */


  Modify.prototype.createOrUpdateVertexFeature_ = function (coordinates, features, geometries) {
    var vertexFeature = this.vertexFeature_;

    if (!vertexFeature) {
      vertexFeature = new _Feature["default"](new _Point["default"](coordinates));
      this.vertexFeature_ = vertexFeature;
      this.overlay_.getSource().addFeature(vertexFeature);
    } else {
      var geometry = vertexFeature.getGeometry();
      geometry.setCoordinates(coordinates);
    }

    vertexFeature.set('features', features);
    vertexFeature.set('geometries', geometries);
    return vertexFeature;
  };
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may modify the geometry.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */


  Modify.prototype.handleEvent = function (mapBrowserEvent) {
    if (!mapBrowserEvent.originalEvent) {
      return true;
    }

    this.lastPointerEvent_ = mapBrowserEvent;
    var handled;

    if (!mapBrowserEvent.map.getView().getInteracting() && mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERMOVE && !this.handlingDownUpSequence) {
      this.handlePointerMove_(mapBrowserEvent);
    }

    if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
      if (mapBrowserEvent.type != _MapBrowserEventType["default"].SINGLECLICK || !this.ignoreNextSingleClick_) {
        handled = this.removePoint();
      } else {
        handled = true;
      }
    }

    if (mapBrowserEvent.type == _MapBrowserEventType["default"].SINGLECLICK) {
      this.ignoreNextSingleClick_ = false;
    }

    return _super.prototype.handleEvent.call(this, mapBrowserEvent) && !handled;
  };
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   */


  Modify.prototype.handleDragEvent = function (evt) {
    this.ignoreNextSingleClick_ = false;
    this.willModifyFeatures_(evt, this.dragSegments_);
    var vertex = [evt.coordinate[0] + this.delta_[0], evt.coordinate[1] + this.delta_[1]];
    var features = [];
    var geometries = [];

    for (var i = 0, ii = this.dragSegments_.length; i < ii; ++i) {
      var dragSegment = this.dragSegments_[i];
      var segmentData = dragSegment[0];
      var feature = segmentData.feature;

      if (features.indexOf(feature) === -1) {
        features.push(feature);
      }

      var geometry = segmentData.geometry;

      if (geometries.indexOf(geometry) === -1) {
        geometries.push(geometry);
      }

      var depth = segmentData.depth;
      var coordinates = void 0;
      var segment = segmentData.segment;
      var index = dragSegment[1];

      while (vertex.length < geometry.getStride()) {
        vertex.push(segment[index][vertex.length]);
      }

      switch (geometry.getType()) {
        case _GeometryType["default"].POINT:
          coordinates = vertex;
          segment[0] = vertex;
          segment[1] = vertex;
          break;

        case _GeometryType["default"].MULTI_POINT:
          coordinates = geometry.getCoordinates();
          coordinates[segmentData.index] = vertex;
          segment[0] = vertex;
          segment[1] = vertex;
          break;

        case _GeometryType["default"].LINE_STRING:
          coordinates = geometry.getCoordinates();
          coordinates[segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;

        case _GeometryType["default"].MULTI_LINE_STRING:
          coordinates = geometry.getCoordinates();
          coordinates[depth[0]][segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;

        case _GeometryType["default"].POLYGON:
          coordinates = geometry.getCoordinates();
          coordinates[depth[0]][segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;

        case _GeometryType["default"].MULTI_POLYGON:
          coordinates = geometry.getCoordinates();
          coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
          segment[index] = vertex;
          break;

        case _GeometryType["default"].CIRCLE:
          segment[0] = vertex;
          segment[1] = vertex;

          if (segmentData.index === CIRCLE_CENTER_INDEX) {
            this.changingFeature_ = true;
            geometry.setCenter(vertex);
            this.changingFeature_ = false;
          } else {
            // We're dragging the circle's circumference:
            this.changingFeature_ = true;
            var projection = evt.map.getView().getProjection();
            var radius = (0, _coordinate.distance)((0, _proj.fromUserCoordinate)(geometry.getCenter(), projection), (0, _proj.fromUserCoordinate)(vertex, projection));
            var userProjection = (0, _proj.getUserProjection)();

            if (userProjection) {
              var circleGeometry = geometry.clone().transform(userProjection, projection);
              circleGeometry.setRadius(radius);
              radius = circleGeometry.transform(projection, userProjection).getRadius();
            }

            geometry.setRadius(radius);
            this.changingFeature_ = false;
          }

          break;

        default: // pass

      }

      if (coordinates) {
        this.setGeometryCoordinates_(geometry, coordinates);
      }
    }

    this.createOrUpdateVertexFeature_(vertex, features, geometries);
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   */


  Modify.prototype.handleDownEvent = function (evt) {
    if (!this.condition_(evt)) {
      return false;
    }

    var pixelCoordinate = evt.coordinate;
    this.handlePointerAtPixel_(evt.pixel, evt.map, pixelCoordinate);
    this.dragSegments_.length = 0;
    this.featuresBeingModified_ = null;
    var vertexFeature = this.vertexFeature_;

    if (vertexFeature) {
      var projection = evt.map.getView().getProjection();
      var insertVertices = [];
      var vertex = vertexFeature.getGeometry().getCoordinates();
      var vertexExtent = (0, _extent.boundingExtent)([vertex]);
      var segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
      var componentSegments = {};
      segmentDataMatches.sort(compareIndexes);

      for (var i = 0, ii = segmentDataMatches.length; i < ii; ++i) {
        var segmentDataMatch = segmentDataMatches[i];
        var segment = segmentDataMatch.segment;
        var uid = (0, _util.getUid)(segmentDataMatch.geometry);
        var depth = segmentDataMatch.depth;

        if (depth) {
          uid += '-' + depth.join('-'); // separate feature components
        }

        if (!componentSegments[uid]) {
          componentSegments[uid] = new Array(2);
        }

        if (segmentDataMatch.geometry.getType() === _GeometryType["default"].CIRCLE && segmentDataMatch.index === CIRCLE_CIRCUMFERENCE_INDEX) {
          var closestVertex = closestOnSegmentData(pixelCoordinate, segmentDataMatch, projection);

          if ((0, _coordinate.equals)(closestVertex, vertex) && !componentSegments[uid][0]) {
            this.dragSegments_.push([segmentDataMatch, 0]);
            componentSegments[uid][0] = segmentDataMatch;
          }

          continue;
        }

        if ((0, _coordinate.equals)(segment[0], vertex) && !componentSegments[uid][0]) {
          this.dragSegments_.push([segmentDataMatch, 0]);
          componentSegments[uid][0] = segmentDataMatch;
          continue;
        }

        if ((0, _coordinate.equals)(segment[1], vertex) && !componentSegments[uid][1]) {
          // prevent dragging closed linestrings by the connecting node
          if ((segmentDataMatch.geometry.getType() === _GeometryType["default"].LINE_STRING || segmentDataMatch.geometry.getType() === _GeometryType["default"].MULTI_LINE_STRING) && componentSegments[uid][0] && componentSegments[uid][0].index === 0) {
            continue;
          }

          this.dragSegments_.push([segmentDataMatch, 1]);
          componentSegments[uid][1] = segmentDataMatch;
          continue;
        }

        if ((0, _util.getUid)(segment) in this.vertexSegments_ && !componentSegments[uid][0] && !componentSegments[uid][1] && this.insertVertexCondition_(evt)) {
          insertVertices.push(segmentDataMatch);
        }
      }

      if (insertVertices.length) {
        this.willModifyFeatures_(evt, [insertVertices]);
      }

      for (var j = insertVertices.length - 1; j >= 0; --j) {
        this.insertVertex_(insertVertices[j], vertex);
      }
    }

    return !!this.vertexFeature_;
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @return {boolean} If the event was consumed.
   */


  Modify.prototype.handleUpEvent = function (evt) {
    for (var i = this.dragSegments_.length - 1; i >= 0; --i) {
      var segmentData = this.dragSegments_[i][0];
      var geometry = segmentData.geometry;

      if (geometry.getType() === _GeometryType["default"].CIRCLE) {
        // Update a circle object in the R* bush:
        var coordinates = geometry.getCenter();
        var centerSegmentData = segmentData.featureSegments[0];
        var circumferenceSegmentData = segmentData.featureSegments[1];
        centerSegmentData.segment[0] = coordinates;
        centerSegmentData.segment[1] = coordinates;
        circumferenceSegmentData.segment[0] = coordinates;
        circumferenceSegmentData.segment[1] = coordinates;
        this.rBush_.update((0, _extent.createOrUpdateFromCoordinate)(coordinates), centerSegmentData);
        var circleGeometry = geometry;
        var userProjection = (0, _proj.getUserProjection)();

        if (userProjection) {
          var projection = evt.map.getView().getProjection();
          circleGeometry = circleGeometry.clone().transform(userProjection, projection);
          circleGeometry = (0, _Polygon.fromCircle)(circleGeometry).transform(projection, userProjection);
        }

        this.rBush_.update(circleGeometry.getExtent(), circumferenceSegmentData);
      } else {
        this.rBush_.update((0, _extent.boundingExtent)(segmentData.segment), segmentData);
      }
    }

    if (this.featuresBeingModified_) {
      this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
      this.featuresBeingModified_ = null;
    }

    return false;
  };
  /**
   * @param {import("../MapBrowserEvent.js").default} evt Event.
   * @private
   */


  Modify.prototype.handlePointerMove_ = function (evt) {
    this.lastPixel_ = evt.pixel;
    this.handlePointerAtPixel_(evt.pixel, evt.map, evt.coordinate);
  };
  /**
   * @param {import("../pixel.js").Pixel} pixel Pixel
   * @param {import("../PluggableMap.js").default} map Map.
   * @param {import("../coordinate.js").Coordinate} [opt_coordinate] The pixel Coordinate.
   * @private
   */


  Modify.prototype.handlePointerAtPixel_ = function (pixel, map, opt_coordinate) {
    var _this = this;

    var pixelCoordinate = opt_coordinate || map.getCoordinateFromPixel(pixel);
    var projection = map.getView().getProjection();

    var sortByDistance = function sortByDistance(a, b) {
      return projectedDistanceToSegmentDataSquared(pixelCoordinate, a, projection) - projectedDistanceToSegmentDataSquared(pixelCoordinate, b, projection);
    };
    /** @type {Array<SegmentData>|undefined} */


    var nodes;
    var hitPointGeometry;

    if (this.hitDetection_) {
      var layerFilter = _typeof(this.hitDetection_) === 'object' ? function (layer) {
        return layer === _this.hitDetection_;
      } : undefined;
      map.forEachFeatureAtPixel(pixel, function (feature, layer, geometry) {
        geometry = geometry ||
        /** @type {import("../geom/SimpleGeometry").default} */
        feature.getGeometry();

        if (geometry.getType() === _GeometryType["default"].POINT && (0, _array.includes)(_this.features_.getArray(), feature)) {
          hitPointGeometry = geometry;
          var coordinate = geometry.getFlatCoordinates().slice(0, 2);
          nodes = [{
            feature: feature,
            geometry: geometry,
            segment: [coordinate, coordinate]
          }];
        }

        return true;
      }, {
        layerFilter: layerFilter
      });
    }

    if (!nodes) {
      var viewExtent = (0, _proj.fromUserExtent)((0, _extent.createOrUpdateFromCoordinate)(pixelCoordinate, tempExtent), projection);
      var buffer = map.getView().getResolution() * this.pixelTolerance_;
      var box = (0, _proj.toUserExtent)((0, _extent.buffer)(viewExtent, buffer, tempExtent), projection);
      nodes = this.rBush_.getInExtent(box);
    }

    if (nodes && nodes.length > 0) {
      var node = nodes.sort(sortByDistance)[0];
      var closestSegment = node.segment;
      var vertex = closestOnSegmentData(pixelCoordinate, node, projection);
      var vertexPixel = map.getPixelFromCoordinate(vertex);
      var dist = (0, _coordinate.distance)(pixel, vertexPixel);

      if (hitPointGeometry || dist <= this.pixelTolerance_) {
        /** @type {Object<string, boolean>} */
        var vertexSegments = {};
        vertexSegments[(0, _util.getUid)(closestSegment)] = true;

        if (!this.snapToPointer_) {
          this.delta_[0] = vertex[0] - pixelCoordinate[0];
          this.delta_[1] = vertex[1] - pixelCoordinate[1];
        }

        if (node.geometry.getType() === _GeometryType["default"].CIRCLE && node.index === CIRCLE_CIRCUMFERENCE_INDEX) {
          this.snappedToVertex_ = true;
          this.createOrUpdateVertexFeature_(vertex, [node.feature], [node.geometry]);
        } else {
          var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
          var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
          var squaredDist1 = (0, _coordinate.squaredDistance)(vertexPixel, pixel1);
          var squaredDist2 = (0, _coordinate.squaredDistance)(vertexPixel, pixel2);
          dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
          this.snappedToVertex_ = dist <= this.pixelTolerance_;

          if (this.snappedToVertex_) {
            vertex = squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
          }

          this.createOrUpdateVertexFeature_(vertex, [node.feature], [node.geometry]);
          var geometries = {};
          geometries[(0, _util.getUid)(node.geometry)] = true;

          for (var i = 1, ii = nodes.length; i < ii; ++i) {
            var segment = nodes[i].segment;

            if ((0, _coordinate.equals)(closestSegment[0], segment[0]) && (0, _coordinate.equals)(closestSegment[1], segment[1]) || (0, _coordinate.equals)(closestSegment[0], segment[1]) && (0, _coordinate.equals)(closestSegment[1], segment[0])) {
              var geometryUid = (0, _util.getUid)(nodes[i].geometry);

              if (!(geometryUid in geometries)) {
                geometries[geometryUid] = true;
                vertexSegments[(0, _util.getUid)(segment)] = true;
              }
            } else {
              break;
            }
          }
        }

        this.vertexSegments_ = vertexSegments;
        return;
      }
    }

    if (this.vertexFeature_) {
      this.overlay_.getSource().removeFeature(this.vertexFeature_);
      this.vertexFeature_ = null;
    }
  };
  /**
   * @param {SegmentData} segmentData Segment data.
   * @param {import("../coordinate.js").Coordinate} vertex Vertex.
   * @private
   */


  Modify.prototype.insertVertex_ = function (segmentData, vertex) {
    var segment = segmentData.segment;
    var feature = segmentData.feature;
    var geometry = segmentData.geometry;
    var depth = segmentData.depth;
    var index = segmentData.index;
    var coordinates;

    while (vertex.length < geometry.getStride()) {
      vertex.push(0);
    }

    switch (geometry.getType()) {
      case _GeometryType["default"].MULTI_LINE_STRING:
        coordinates = geometry.getCoordinates();
        coordinates[depth[0]].splice(index + 1, 0, vertex);
        break;

      case _GeometryType["default"].POLYGON:
        coordinates = geometry.getCoordinates();
        coordinates[depth[0]].splice(index + 1, 0, vertex);
        break;

      case _GeometryType["default"].MULTI_POLYGON:
        coordinates = geometry.getCoordinates();
        coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
        break;

      case _GeometryType["default"].LINE_STRING:
        coordinates = geometry.getCoordinates();
        coordinates.splice(index + 1, 0, vertex);
        break;

      default:
        return;
    }

    this.setGeometryCoordinates_(geometry, coordinates);
    var rTree = this.rBush_;
    rTree.remove(segmentData);
    this.updateSegmentIndices_(geometry, index, depth, 1);
    /** @type {SegmentData} */

    var newSegmentData = {
      segment: [segment[0], vertex],
      feature: feature,
      geometry: geometry,
      depth: depth,
      index: index
    };
    rTree.insert((0, _extent.boundingExtent)(newSegmentData.segment), newSegmentData);
    this.dragSegments_.push([newSegmentData, 1]);
    /** @type {SegmentData} */

    var newSegmentData2 = {
      segment: [vertex, segment[1]],
      feature: feature,
      geometry: geometry,
      depth: depth,
      index: index + 1
    };
    rTree.insert((0, _extent.boundingExtent)(newSegmentData2.segment), newSegmentData2);
    this.dragSegments_.push([newSegmentData2, 0]);
    this.ignoreNextSingleClick_ = true;
  };
  /**
   * Removes the vertex currently being pointed.
   * @return {boolean} True when a vertex was removed.
   * @api
   */


  Modify.prototype.removePoint = function () {
    if (this.lastPointerEvent_ && this.lastPointerEvent_.type != _MapBrowserEventType["default"].POINTERDRAG) {
      var evt = this.lastPointerEvent_;
      this.willModifyFeatures_(evt, this.dragSegments_);
      var removed = this.removeVertex_();

      if (this.featuresBeingModified_) {
        this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
      }

      this.featuresBeingModified_ = null;
      return removed;
    }

    return false;
  };
  /**
   * Removes a vertex from all matching features.
   * @return {boolean} True when a vertex was removed.
   * @private
   */


  Modify.prototype.removeVertex_ = function () {
    var dragSegments = this.dragSegments_;
    var segmentsByFeature = {};
    var deleted = false;
    var component, coordinates, dragSegment, geometry, i, index, left;
    var newIndex, right, segmentData, uid;

    for (i = dragSegments.length - 1; i >= 0; --i) {
      dragSegment = dragSegments[i];
      segmentData = dragSegment[0];
      uid = (0, _util.getUid)(segmentData.feature);

      if (segmentData.depth) {
        // separate feature components
        uid += '-' + segmentData.depth.join('-');
      }

      if (!(uid in segmentsByFeature)) {
        segmentsByFeature[uid] = {};
      }

      if (dragSegment[1] === 0) {
        segmentsByFeature[uid].right = segmentData;
        segmentsByFeature[uid].index = segmentData.index;
      } else if (dragSegment[1] == 1) {
        segmentsByFeature[uid].left = segmentData;
        segmentsByFeature[uid].index = segmentData.index + 1;
      }
    }

    for (uid in segmentsByFeature) {
      right = segmentsByFeature[uid].right;
      left = segmentsByFeature[uid].left;
      index = segmentsByFeature[uid].index;
      newIndex = index - 1;

      if (left !== undefined) {
        segmentData = left;
      } else {
        segmentData = right;
      }

      if (newIndex < 0) {
        newIndex = 0;
      }

      geometry = segmentData.geometry;
      coordinates = geometry.getCoordinates();
      component = coordinates;
      deleted = false;

      switch (geometry.getType()) {
        case _GeometryType["default"].MULTI_LINE_STRING:
          if (coordinates[segmentData.depth[0]].length > 2) {
            coordinates[segmentData.depth[0]].splice(index, 1);
            deleted = true;
          }

          break;

        case _GeometryType["default"].LINE_STRING:
          if (coordinates.length > 2) {
            coordinates.splice(index, 1);
            deleted = true;
          }

          break;

        case _GeometryType["default"].MULTI_POLYGON:
          component = component[segmentData.depth[1]];

        /* falls through */

        case _GeometryType["default"].POLYGON:
          component = component[segmentData.depth[0]];

          if (component.length > 4) {
            if (index == component.length - 1) {
              index = 0;
            }

            component.splice(index, 1);
            deleted = true;

            if (index === 0) {
              // close the ring again
              component.pop();
              component.push(component[0]);
              newIndex = component.length - 1;
            }
          }

          break;

        default: // pass

      }

      if (deleted) {
        this.setGeometryCoordinates_(geometry, coordinates);
        var segments = [];

        if (left !== undefined) {
          this.rBush_.remove(left);
          segments.push(left.segment[0]);
        }

        if (right !== undefined) {
          this.rBush_.remove(right);
          segments.push(right.segment[1]);
        }

        if (left !== undefined && right !== undefined) {
          /** @type {SegmentData} */
          var newSegmentData = {
            depth: segmentData.depth,
            feature: segmentData.feature,
            geometry: segmentData.geometry,
            index: newIndex,
            segment: segments
          };
          this.rBush_.insert((0, _extent.boundingExtent)(newSegmentData.segment), newSegmentData);
        }

        this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);

        if (this.vertexFeature_) {
          this.overlay_.getSource().removeFeature(this.vertexFeature_);
          this.vertexFeature_ = null;
        }

        dragSegments.length = 0;
      }
    }

    return deleted;
  };
  /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {Array} coordinates Coordinates.
   * @private
   */


  Modify.prototype.setGeometryCoordinates_ = function (geometry, coordinates) {
    this.changingFeature_ = true;
    geometry.setCoordinates(coordinates);
    this.changingFeature_ = false;
  };
  /**
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {number} index Index.
   * @param {Array<number>|undefined} depth Depth.
   * @param {number} delta Delta (1 or -1).
   * @private
   */


  Modify.prototype.updateSegmentIndices_ = function (geometry, index, depth, delta) {
    this.rBush_.forEachInExtent(geometry.getExtent(), function (segmentDataMatch) {
      if (segmentDataMatch.geometry === geometry && (depth === undefined || segmentDataMatch.depth === undefined || (0, _array.equals)(segmentDataMatch.depth, depth)) && segmentDataMatch.index > index) {
        segmentDataMatch.index += delta;
      }
    });
  };

  return Modify;
}(_Pointer["default"]);
/**
 * @param {SegmentData} a The first segment data.
 * @param {SegmentData} b The second segment data.
 * @return {number} The difference in indexes.
 */


function compareIndexes(a, b) {
  return a.index - b.index;
}
/**
 * Returns the distance from a point to a line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
 *        which to calculate the distance.
 * @param {SegmentData} segmentData The object describing the line
 *        segment we are calculating the distance to.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {number} The square of the distance between a point and a line segment.
 */


function projectedDistanceToSegmentDataSquared(pointCoordinates, segmentData, projection) {
  var geometry = segmentData.geometry;

  if (geometry.getType() === _GeometryType["default"].CIRCLE) {
    var circleGeometry =
    /** @type {import("../geom/Circle.js").default} */
    geometry;

    if (segmentData.index === CIRCLE_CIRCUMFERENCE_INDEX) {
      var userProjection = (0, _proj.getUserProjection)();

      if (userProjection) {
        circleGeometry =
        /** @type {import("../geom/Circle.js").default} */
        circleGeometry.clone().transform(userProjection, projection);
      }

      var distanceToCenterSquared = (0, _coordinate.squaredDistance)(circleGeometry.getCenter(), (0, _proj.fromUserCoordinate)(pointCoordinates, projection));
      var distanceToCircumference = Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
      return distanceToCircumference * distanceToCircumference;
    }
  }

  var coordinate = (0, _proj.fromUserCoordinate)(pointCoordinates, projection);
  tempSegment[0] = (0, _proj.fromUserCoordinate)(segmentData.segment[0], projection);
  tempSegment[1] = (0, _proj.fromUserCoordinate)(segmentData.segment[1], projection);
  return (0, _coordinate.squaredDistanceToSegment)(coordinate, tempSegment);
}
/**
 * Returns the point closest to a given line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
 *        should be found.
 * @param {SegmentData} segmentData The object describing the line
 *        segment which should contain the closest point.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
 */


function closestOnSegmentData(pointCoordinates, segmentData, projection) {
  var geometry = segmentData.geometry;

  if (geometry.getType() === _GeometryType["default"].CIRCLE && segmentData.index === CIRCLE_CIRCUMFERENCE_INDEX) {
    var circleGeometry =
    /** @type {import("../geom/Circle.js").default} */
    geometry;
    var userProjection = (0, _proj.getUserProjection)();

    if (userProjection) {
      circleGeometry =
      /** @type {import("../geom/Circle.js").default} */
      circleGeometry.clone().transform(userProjection, projection);
    }

    return (0, _proj.toUserCoordinate)(circleGeometry.getClosestPoint((0, _proj.fromUserCoordinate)(pointCoordinates, projection)), projection);
  }

  var coordinate = (0, _proj.fromUserCoordinate)(pointCoordinates, projection);
  tempSegment[0] = (0, _proj.fromUserCoordinate)(segmentData.segment[0], projection);
  tempSegment[1] = (0, _proj.fromUserCoordinate)(segmentData.segment[1], projection);
  return (0, _proj.toUserCoordinate)((0, _coordinate.closestOnSegment)(coordinate, tempSegment), projection);
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */


function getDefaultStyleFunction() {
  var style = (0, _Style.createEditingStyle)();
  return function (feature, resolution) {
    return style[_GeometryType["default"].POINT];
  };
}

var _default = Modify;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQU1BOztBQUtBOztBQU9BOztBQUNBOztBQUNBOztBQUNBOztBQU9BOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUE1Q0E7Ozs7O0FBOENBOzs7OztBQUtBLElBQU1BLG1CQUFtQixHQUFHLENBQTVCO0FBRUE7Ozs7OztBQUtBLElBQU1DLDBCQUEwQixHQUFHLENBQW5DO0FBRUEsSUFBTUMsVUFBVSxHQUFHLENBQUMsQ0FBRCxFQUFJLENBQUosRUFBTyxDQUFQLEVBQVUsQ0FBVixDQUFuQjtBQUNBLElBQU1DLFdBQVcsR0FBRyxFQUFwQjtBQUVBOzs7O0FBR0EsSUFBTUMsZUFBZSxHQUFHO0VBQ3RCOzs7OztFQUtBQyxXQUFXLEVBQUUsYUFOUzs7RUFPdEI7Ozs7O0VBS0FDLFNBQVMsRUFBRTtBQVpXLENBQXhCO0FBZUE7Ozs7Ozs7Ozs7QUFVQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTJDQTs7Ozs7O0FBS0E7QUFBQTtBQUFBO0VBQWlDQztFQUMvQjs7Ozs7Ozs7O0VBT0EscUJBQVlDLElBQVosRUFBa0JDLFFBQWxCLEVBQTRCQyxlQUE1QixFQUEyQztJQUEzQyxZQUNFQyxrQkFBTUgsSUFBTixLQUFXLElBRGI7SUFHRTs7Ozs7OztJQUtBSSxLQUFJLENBQUNILFFBQUwsR0FBZ0JBLFFBQWhCO0lBRUE7Ozs7OztJQUtBRyxLQUFJLENBQUNGLGVBQUwsR0FBdUJBLGVBQXZCOztFQUNEOztFQUNIO0FBQUMsQ0F6QkQsQ0FBaUNHLGlCQUFqQzs7OztBQTJCQTs7Ozs7Ozs7OztBQVVBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFxQkE7QUFBQTtBQUFBO0VBQXFCTjtFQUNuQjs7Ozs7RUFHQSxnQkFBWU8sT0FBWixFQUFtQjtJQUFuQixZQUNFSDtJQUFNO0lBQStDRyxPQUFyRCxLQUE4RCxJQURoRTtJQUdFOzs7OztJQUdBRixLQUFJLENBQUNHLEVBQUw7SUFFQTs7OztJQUdBSCxLQUFJLENBQUNJLElBQUw7SUFFQTs7OztJQUdBSixLQUFJLENBQUNLLEVBQUw7SUFFQTs7SUFDQUwsS0FBSSxDQUFDTSx5QkFBTCxHQUFpQ04sS0FBSSxDQUFDTyxvQkFBTCxDQUEwQkMsSUFBMUIsQ0FBK0JSLEtBQS9CLENBQWpDO0lBRUE7Ozs7O0lBSUFBLEtBQUksQ0FBQ1MsVUFBTCxHQUFrQlAsT0FBTyxDQUFDUSxTQUFSLEdBQW9CUixPQUFPLENBQUNRLFNBQTVCLEdBQXdDQyx3QkFBMUQ7SUFFQTs7Ozs7O0lBS0FYLEtBQUksQ0FBQ1ksdUJBQUwsR0FBK0IsVUFBVWQsZUFBVixFQUF5QjtNQUN0RCxPQUFPLDJCQUFXQSxlQUFYLEtBQStCLDRCQUFZQSxlQUFaLENBQXRDO0lBQ0QsQ0FGRDtJQUlBOzs7Ozs7SUFJQUUsS0FBSSxDQUFDYSxnQkFBTCxHQUF3QlgsT0FBTyxDQUFDWSxlQUFSLEdBQ3BCWixPQUFPLENBQUNZLGVBRFksR0FFcEJkLEtBQUksQ0FBQ1ksdUJBRlQ7SUFJQTs7Ozs7SUFJQVosS0FBSSxDQUFDZSxzQkFBTCxHQUE4QmIsT0FBTyxDQUFDYyxxQkFBUixHQUMxQmQsT0FBTyxDQUFDYyxxQkFEa0IsR0FFMUJDLGlCQUZKO0lBSUE7Ozs7OztJQUtBakIsS0FBSSxDQUFDa0IsY0FBTCxHQUFzQixJQUF0QjtJQUVBOzs7Ozs7SUFLQWxCLEtBQUksQ0FBQ21CLGVBQUwsR0FBdUIsSUFBdkI7SUFFQTs7Ozs7SUFJQW5CLEtBQUksQ0FBQ29CLFVBQUwsR0FBa0IsQ0FBQyxDQUFELEVBQUksQ0FBSixDQUFsQjtJQUVBOzs7Ozs7O0lBTUFwQixLQUFJLENBQUNxQixzQkFBTCxHQUE4QixLQUE5QjtJQUVBOzs7OztJQUlBckIsS0FBSSxDQUFDc0Isc0JBQUwsR0FBOEIsSUFBOUI7SUFFQTs7Ozs7O0lBS0F0QixLQUFJLENBQUN1QixNQUFMLEdBQWMsSUFBSUMsaUJBQUosRUFBZDtJQUVBOzs7OztJQUlBeEIsS0FBSSxDQUFDeUIsZUFBTCxHQUNFdkIsT0FBTyxDQUFDd0IsY0FBUixLQUEyQkMsU0FBM0IsR0FBdUN6QixPQUFPLENBQUN3QixjQUEvQyxHQUFnRSxFQURsRTtJQUdBOzs7OztJQUlBMUIsS0FBSSxDQUFDNEIsZ0JBQUwsR0FBd0IsS0FBeEI7SUFFQTs7Ozs7OztJQU1BNUIsS0FBSSxDQUFDNkIsZ0JBQUwsR0FBd0IsS0FBeEI7SUFFQTs7Ozs7SUFJQTdCLEtBQUksQ0FBQzhCLGFBQUwsR0FBcUIsRUFBckI7SUFFQTs7Ozs7O0lBS0E5QixLQUFJLENBQUMrQixRQUFMLEdBQWdCLElBQUlDLGtCQUFKLENBQWdCO01BQzlCQyxNQUFNLEVBQUUsSUFBSUMsbUJBQUosQ0FBaUI7UUFDdkJDLGVBQWUsRUFBRSxLQURNO1FBRXZCQyxLQUFLLEVBQUUsQ0FBQyxDQUFDbEMsT0FBTyxDQUFDa0M7TUFGTSxDQUFqQixDQURzQjtNQUs5QkMsS0FBSyxFQUFFbkMsT0FBTyxDQUFDbUMsS0FBUixHQUFnQm5DLE9BQU8sQ0FBQ21DLEtBQXhCLEdBQWdDQyx1QkFBdUIsRUFMaEM7TUFNOUJDLG9CQUFvQixFQUFFLElBTlE7TUFPOUJDLHNCQUFzQixFQUFFO0lBUE0sQ0FBaEIsQ0FBaEI7SUFVQTs7Ozs7O0lBS0F4QyxLQUFJLENBQUN5QyxnQkFBTCxHQUF3QjtNQUN0QixTQUFTekMsS0FBSSxDQUFDMEMsbUJBQUwsQ0FBeUJsQyxJQUF6QixDQUE4QlIsS0FBOUIsQ0FEYTtNQUV0QixjQUFjQSxLQUFJLENBQUMyQyx3QkFBTCxDQUE4Qm5DLElBQTlCLENBQW1DUixLQUFuQyxDQUZRO01BR3RCLGNBQWNBLEtBQUksQ0FBQzJDLHdCQUFMLENBQThCbkMsSUFBOUIsQ0FBbUNSLEtBQW5DLENBSFE7TUFJdEIsV0FBV0EsS0FBSSxDQUFDNEMscUJBQUwsQ0FBMkJwQyxJQUEzQixDQUFnQ1IsS0FBaEMsQ0FKVztNQUt0QixjQUFjQSxLQUFJLENBQUM2Qyx3QkFBTCxDQUE4QnJDLElBQTlCLENBQW1DUixLQUFuQyxDQUxRO01BTXRCLG1CQUFtQkEsS0FBSSxDQUFDOEMsNkJBQUwsQ0FBbUN0QyxJQUFuQyxDQUF3Q1IsS0FBeEMsQ0FORztNQU90QixnQkFBZ0JBLEtBQUksQ0FBQytDLDBCQUFMLENBQWdDdkMsSUFBaEMsQ0FBcUNSLEtBQXJDLENBUE07TUFRdEIsVUFBVUEsS0FBSSxDQUFDZ0Qsb0JBQUwsQ0FBMEJ4QyxJQUExQixDQUErQlIsS0FBL0IsQ0FSWTtNQVN0QixzQkFBc0JBLEtBQUksQ0FBQ2lELGdDQUFMLENBQXNDekMsSUFBdEMsQ0FBMkNSLEtBQTNDO0lBVEEsQ0FBeEI7SUFZQTs7Ozs7SUFJQUEsS0FBSSxDQUFDa0QsT0FBTCxHQUFlLElBQWY7SUFFQTs7OztJQUdBbEQsS0FBSSxDQUFDbUQsYUFBTCxHQUFxQixJQUFyQjtJQUVBLElBQUl0RCxRQUFKOztJQUNBLElBQUlLLE9BQU8sQ0FBQ0wsUUFBWixFQUFzQjtNQUNwQkEsUUFBUSxHQUFHSyxPQUFPLENBQUNMLFFBQW5CO0lBQ0QsQ0FGRCxNQUVPLElBQUlLLE9BQU8sQ0FBQytCLE1BQVosRUFBb0I7TUFDekJqQyxLQUFJLENBQUNrRCxPQUFMLEdBQWVoRCxPQUFPLENBQUMrQixNQUF2QjtNQUNBcEMsUUFBUSxHQUFHLElBQUl1RCxzQkFBSixDQUFlcEQsS0FBSSxDQUFDa0QsT0FBTCxDQUFhRyxXQUFiLEVBQWYsQ0FBWDs7TUFDQXJELEtBQUksQ0FBQ2tELE9BQUwsQ0FBYUksZ0JBQWIsQ0FDRUMsNEJBQWdCQyxVQURsQixFQUVFeEQsS0FBSSxDQUFDeUQsZ0JBQUwsQ0FBc0JqRCxJQUF0QixDQUEyQlIsS0FBM0IsQ0FGRjs7TUFJQUEsS0FBSSxDQUFDa0QsT0FBTCxDQUFhSSxnQkFBYixDQUNFQyw0QkFBZ0JHLGFBRGxCLEVBRUUxRCxLQUFJLENBQUMyRCxtQkFBTCxDQUF5Qm5ELElBQXpCLENBQThCUixLQUE5QixDQUZGO0lBSUQ7O0lBQ0QsSUFBSSxDQUFDSCxRQUFMLEVBQWU7TUFDYixNQUFNLElBQUkrRCxLQUFKLENBQ0osK0RBREksQ0FBTjtJQUdEOztJQUNELElBQUkxRCxPQUFPLENBQUMyRCxZQUFaLEVBQTBCO01BQ3hCN0QsS0FBSSxDQUFDbUQsYUFBTCxHQUFxQmpELE9BQU8sQ0FBQzJELFlBQTdCO0lBQ0Q7SUFFRDs7Ozs7O0lBSUE3RCxLQUFJLENBQUM4RCxTQUFMLEdBQWlCakUsUUFBakI7O0lBRUFHLEtBQUksQ0FBQzhELFNBQUwsQ0FBZUMsT0FBZixDQUF1Qi9ELEtBQUksQ0FBQ2dFLFdBQUwsQ0FBaUJ4RCxJQUFqQixDQUFzQlIsS0FBdEIsQ0FBdkI7O0lBQ0FBLEtBQUksQ0FBQzhELFNBQUwsQ0FBZVIsZ0JBQWYsQ0FDRVcsZ0NBQW9CQyxHQUR0QixFQUVFbEUsS0FBSSxDQUFDbUUsaUJBQUwsQ0FBdUIzRCxJQUF2QixDQUE0QlIsS0FBNUIsQ0FGRjs7SUFJQUEsS0FBSSxDQUFDOEQsU0FBTCxDQUFlUixnQkFBZixDQUNFVyxnQ0FBb0JHLE1BRHRCLEVBRUVwRSxLQUFJLENBQUNxRSxvQkFBTCxDQUEwQjdELElBQTFCLENBQStCUixLQUEvQixDQUZGO0lBS0E7Ozs7OztJQUlBQSxLQUFJLENBQUNzRSxpQkFBTCxHQUF5QixJQUF6QjtJQUVBOzs7OztJQUlBdEUsS0FBSSxDQUFDdUUsTUFBTCxHQUFjLENBQUMsQ0FBRCxFQUFJLENBQUosQ0FBZDtJQUVBOzs7O0lBR0F2RSxLQUFJLENBQUN3RSxjQUFMLEdBQ0V0RSxPQUFPLENBQUN1RSxhQUFSLEtBQTBCOUMsU0FBMUIsR0FDSSxDQUFDM0IsS0FBSSxDQUFDbUQsYUFEVixHQUVJakQsT0FBTyxDQUFDdUUsYUFIZDs7RUFJRDtFQUVEOzs7Ozs7RUFJQUMseUNBQVlDLE9BQVosRUFBbUI7SUFDakIsSUFBTUMsUUFBUSxHQUFHRCxPQUFPLENBQUNFLFdBQVIsRUFBakI7O0lBQ0EsSUFBSUQsUUFBSixFQUFjO01BQ1osSUFBTUUsTUFBTSxHQUFHLEtBQUtyQyxnQkFBTCxDQUFzQm1DLFFBQVEsQ0FBQ0csT0FBVCxFQUF0QixDQUFmOztNQUNBLElBQUlELE1BQUosRUFBWTtRQUNWQSxNQUFNLENBQUNILE9BQUQsRUFBVUMsUUFBVixDQUFOO01BQ0Q7SUFDRjs7SUFDRCxJQUFNSSxHQUFHLEdBQUcsS0FBS0MsTUFBTCxFQUFaOztJQUNBLElBQUlELEdBQUcsSUFBSUEsR0FBRyxDQUFDRSxVQUFKLEVBQVAsSUFBMkIsS0FBS0MsU0FBTCxFQUEvQixFQUFpRDtNQUMvQyxLQUFLQyxxQkFBTCxDQUEyQixLQUFLaEUsVUFBaEMsRUFBNEM0RCxHQUE1QztJQUNEOztJQUNETCxPQUFPLENBQUNyQixnQkFBUixDQUF5QitCLHNCQUFVQyxNQUFuQyxFQUEyQyxLQUFLaEYseUJBQWhEO0VBQ0QsQ0FiRDtFQWVBOzs7Ozs7O0VBS0FvRSxpREFBb0JhLEdBQXBCLEVBQXlCQyxRQUF6QixFQUFpQztJQUMvQixJQUFJLENBQUMsS0FBS2xFLHNCQUFWLEVBQWtDO01BQ2hDLEtBQUtBLHNCQUFMLEdBQThCLElBQUk4QixzQkFBSixFQUE5QjtNQUNBLElBQU12RCxRQUFRLEdBQUcsS0FBS3lCLHNCQUFMLENBQTRCbUUsUUFBNUIsRUFBakI7O01BQ0EsS0FBSyxJQUFJQyxDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUdILFFBQVEsQ0FBQ0ksTUFBOUIsRUFBc0NGLENBQUMsR0FBR0MsRUFBMUMsRUFBOEMsRUFBRUQsQ0FBaEQsRUFBbUQ7UUFDakQsSUFBTUcsT0FBTyxHQUFHTCxRQUFRLENBQUNFLENBQUQsQ0FBeEI7O1FBQ0EsS0FBSyxJQUFJSSxDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUdGLE9BQU8sQ0FBQ0QsTUFBN0IsRUFBcUNFLENBQUMsR0FBR0MsRUFBekMsRUFBNkMsRUFBRUQsQ0FBL0MsRUFBa0Q7VUFDaEQsSUFBTW5CLE9BQU8sR0FBR2tCLE9BQU8sQ0FBQ0MsQ0FBRCxDQUFQLENBQVduQixPQUEzQjs7VUFDQSxJQUFJQSxPQUFPLElBQUk5RSxRQUFRLENBQUNtRyxPQUFULENBQWlCckIsT0FBakIsTUFBOEIsQ0FBQyxDQUE5QyxFQUFpRDtZQUMvQyxLQUFLckQsc0JBQUwsQ0FBNEIyRSxJQUE1QixDQUFpQ3RCLE9BQWpDO1VBQ0Q7UUFDRjtNQUNGOztNQUNELElBQUksS0FBS3JELHNCQUFMLENBQTRCNEUsU0FBNUIsT0FBNEMsQ0FBaEQsRUFBbUQ7UUFDakQsS0FBSzVFLHNCQUFMLEdBQThCLElBQTlCO01BQ0QsQ0FGRCxNQUVPO1FBQ0wsS0FBSzZFLGFBQUwsQ0FDRSxJQUFJQyxXQUFKLENBQ0U1RyxlQUFlLENBQUNDLFdBRGxCLEVBRUUsS0FBSzZCLHNCQUZQLEVBR0VpRSxHQUhGLENBREY7TUFPRDtJQUNGO0VBQ0YsQ0F6QkQ7RUEyQkE7Ozs7OztFQUlBYiw0Q0FBZUMsT0FBZixFQUFzQjtJQUNwQixLQUFLMEIseUJBQUwsQ0FBK0IxQixPQUEvQixFQURvQixDQUVwQjs7SUFDQSxJQUFJLEtBQUt6RCxjQUFMLElBQXVCLEtBQUs0QyxTQUFMLENBQWVvQyxTQUFmLE9BQStCLENBQTFELEVBQTZEO01BQzNELEtBQUtuRSxRQUFMLENBQWN1RSxTQUFkLEdBQTBCQyxhQUExQixDQUF3QyxLQUFLckYsY0FBN0M7TUFDQSxLQUFLQSxjQUFMLEdBQXNCLElBQXRCO0lBQ0Q7O0lBQ0R5RCxPQUFPLENBQUM2QixtQkFBUixDQUNFbkIsc0JBQVVDLE1BRFosRUFFRSxLQUFLaEYseUJBRlA7RUFJRCxDQVhEO0VBYUE7Ozs7OztFQUlBb0UsdURBQTBCQyxPQUExQixFQUFpQztJQUMvQixJQUFNOEIsS0FBSyxHQUFHLEtBQUtsRixNQUFuQjtJQUNBOztJQUNBLElBQU1tRixhQUFhLEdBQUcsRUFBdEI7SUFDQUQsS0FBSyxDQUFDMUMsT0FBTjtJQUNFOzs7SUFHQSxVQUFVNEMsSUFBVixFQUFjO01BQ1osSUFBSWhDLE9BQU8sS0FBS2dDLElBQUksQ0FBQ2hDLE9BQXJCLEVBQThCO1FBQzVCK0IsYUFBYSxDQUFDVCxJQUFkLENBQW1CVSxJQUFuQjtNQUNEO0lBQ0YsQ0FSSDs7SUFVQSxLQUFLLElBQUlqQixDQUFDLEdBQUdnQixhQUFhLENBQUNkLE1BQWQsR0FBdUIsQ0FBcEMsRUFBdUNGLENBQUMsSUFBSSxDQUE1QyxFQUErQyxFQUFFQSxDQUFqRCxFQUFvRDtNQUNsRCxJQUFNa0IsWUFBWSxHQUFHRixhQUFhLENBQUNoQixDQUFELENBQWxDOztNQUNBLEtBQUssSUFBSW1CLENBQUMsR0FBRyxLQUFLL0UsYUFBTCxDQUFtQjhELE1BQW5CLEdBQTRCLENBQXpDLEVBQTRDaUIsQ0FBQyxJQUFJLENBQWpELEVBQW9ELEVBQUVBLENBQXRELEVBQXlEO1FBQ3ZELElBQUksS0FBSy9FLGFBQUwsQ0FBbUIrRSxDQUFuQixFQUFzQixDQUF0QixNQUE2QkQsWUFBakMsRUFBK0M7VUFDN0MsS0FBSzlFLGFBQUwsQ0FBbUJnRixNQUFuQixDQUEwQkQsQ0FBMUIsRUFBNkIsQ0FBN0I7UUFDRDtNQUNGOztNQUNESixLQUFLLENBQUNNLE1BQU4sQ0FBYUgsWUFBYjtJQUNEO0VBQ0YsQ0F2QkQ7RUF5QkE7Ozs7Ozs7O0VBTUFsQyx1Q0FBVXNDLE1BQVYsRUFBZ0I7SUFDZCxJQUFJLEtBQUs5RixjQUFMLElBQXVCLENBQUM4RixNQUE1QixFQUFvQztNQUNsQyxLQUFLakYsUUFBTCxDQUFjdUUsU0FBZCxHQUEwQkMsYUFBMUIsQ0FBd0MsS0FBS3JGLGNBQTdDO01BQ0EsS0FBS0EsY0FBTCxHQUFzQixJQUF0QjtJQUNEOztJQUNEbkIsaUJBQU1rSCxTQUFOLENBQWVDLElBQWYsQ0FBZSxJQUFmLEVBQWdCRixNQUFoQjtFQUNELENBTkQ7RUFRQTs7Ozs7Ozs7RUFNQXRDLG9DQUFPTSxHQUFQLEVBQVU7SUFDUixLQUFLakQsUUFBTCxDQUFjb0YsTUFBZCxDQUFxQm5DLEdBQXJCOztJQUNBakYsaUJBQU1vSCxNQUFOLENBQVlELElBQVosQ0FBWSxJQUFaLEVBQWFsQyxHQUFiO0VBQ0QsQ0FIRDtFQUtBOzs7Ozs7O0VBS0FOO0lBQ0UsT0FBTyxLQUFLM0MsUUFBWjtFQUNELENBRkQ7RUFJQTs7Ozs7O0VBSUEyQyw4Q0FBaUIwQyxLQUFqQixFQUFzQjtJQUNwQixJQUFJQSxLQUFLLENBQUN6QyxPQUFWLEVBQW1CO01BQ2pCLEtBQUtiLFNBQUwsQ0FBZW1DLElBQWYsQ0FBb0JtQixLQUFLLENBQUN6QyxPQUExQjtJQUNEO0VBQ0YsQ0FKRDtFQU1BOzs7Ozs7RUFJQUQsaURBQW9CMEMsS0FBcEIsRUFBeUI7SUFDdkIsSUFBSUEsS0FBSyxDQUFDekMsT0FBVixFQUFtQjtNQUNqQixLQUFLYixTQUFMLENBQWVpRCxNQUFmLENBQXNCSyxLQUFLLENBQUN6QyxPQUE1QjtJQUNEO0VBQ0YsQ0FKRDtFQU1BOzs7Ozs7RUFJQUQsK0NBQWtCYSxHQUFsQixFQUFxQjtJQUNuQixLQUFLdkIsV0FBTDtJQUFpQjtJQUF3QnVCLEdBQUcsQ0FBQzhCLE9BQTdDO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7RUFJQTNDLGtEQUFxQmEsR0FBckIsRUFBd0I7SUFDdEIsSUFBSSxDQUFDLEtBQUsxRCxnQkFBVixFQUE0QjtNQUMxQixJQUFNOEMsT0FBTztNQUFHO01BQXdCWSxHQUFHLENBQUMrQixNQUE1QztNQUNBLEtBQUtDLGNBQUwsQ0FBb0I1QyxPQUFwQjtNQUNBLEtBQUtYLFdBQUwsQ0FBaUJXLE9BQWpCO0lBQ0Q7RUFDRixDQU5EO0VBUUE7Ozs7OztFQUlBRCxrREFBcUJhLEdBQXJCLEVBQXdCO0lBQ3RCLElBQU1aLE9BQU87SUFBRztJQUF3QlksR0FBRyxDQUFDOEIsT0FBNUM7SUFDQSxLQUFLRSxjQUFMLENBQW9CNUMsT0FBcEI7RUFDRCxDQUhEO0VBS0E7Ozs7Ozs7RUFLQUQsaURBQW9CQyxPQUFwQixFQUE2QkMsUUFBN0IsRUFBcUM7SUFDbkMsSUFBTTRDLFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzZDLGNBQVQsRUFBcEI7SUFFQTs7SUFDQSxJQUFNQyxXQUFXLEdBQUc7TUFDbEIvQyxPQUFPLEVBQUVBLE9BRFM7TUFFbEJDLFFBQVEsRUFBRUEsUUFGUTtNQUdsQmlCLE9BQU8sRUFBRSxDQUFDMkIsV0FBRCxFQUFjQSxXQUFkO0lBSFMsQ0FBcEI7SUFNQSxLQUFLakcsTUFBTCxDQUFZb0csTUFBWixDQUFtQi9DLFFBQVEsQ0FBQ2dELFNBQVQsRUFBbkIsRUFBeUNGLFdBQXpDO0VBQ0QsQ0FYRDtFQWFBOzs7Ozs7O0VBS0FoRCxzREFBeUJDLE9BQXpCLEVBQWtDQyxRQUFsQyxFQUEwQztJQUN4QyxJQUFNaUQsTUFBTSxHQUFHakQsUUFBUSxDQUFDNkMsY0FBVCxFQUFmOztJQUNBLEtBQUssSUFBSS9CLENBQUMsR0FBRyxDQUFSLEVBQVdDLEVBQUUsR0FBR2tDLE1BQU0sQ0FBQ2pDLE1BQTVCLEVBQW9DRixDQUFDLEdBQUdDLEVBQXhDLEVBQTRDLEVBQUVELENBQTlDLEVBQWlEO01BQy9DLElBQU04QixXQUFXLEdBQUdLLE1BQU0sQ0FBQ25DLENBQUQsQ0FBMUI7TUFFQTs7TUFDQSxJQUFNZ0MsV0FBVyxHQUFHO1FBQ2xCL0MsT0FBTyxFQUFFQSxPQURTO1FBRWxCQyxRQUFRLEVBQUVBLFFBRlE7UUFHbEJrRCxLQUFLLEVBQUUsQ0FBQ3BDLENBQUQsQ0FIVztRQUlsQnFDLEtBQUssRUFBRXJDLENBSlc7UUFLbEJHLE9BQU8sRUFBRSxDQUFDMkIsV0FBRCxFQUFjQSxXQUFkO01BTFMsQ0FBcEI7TUFRQSxLQUFLakcsTUFBTCxDQUFZb0csTUFBWixDQUFtQi9DLFFBQVEsQ0FBQ2dELFNBQVQsRUFBbkIsRUFBeUNGLFdBQXpDO0lBQ0Q7RUFDRixDQWhCRDtFQWtCQTs7Ozs7OztFQUtBaEQsc0RBQXlCQyxPQUF6QixFQUFrQ0MsUUFBbEMsRUFBMEM7SUFDeEMsSUFBTTRDLFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzZDLGNBQVQsRUFBcEI7O0lBQ0EsS0FBSyxJQUFJL0IsQ0FBQyxHQUFHLENBQVIsRUFBV0MsRUFBRSxHQUFHNkIsV0FBVyxDQUFDNUIsTUFBWixHQUFxQixDQUExQyxFQUE2Q0YsQ0FBQyxHQUFHQyxFQUFqRCxFQUFxRCxFQUFFRCxDQUF2RCxFQUEwRDtNQUN4RCxJQUFNRyxPQUFPLEdBQUcyQixXQUFXLENBQUNRLEtBQVosQ0FBa0J0QyxDQUFsQixFQUFxQkEsQ0FBQyxHQUFHLENBQXpCLENBQWhCO01BRUE7O01BQ0EsSUFBTWdDLFdBQVcsR0FBRztRQUNsQi9DLE9BQU8sRUFBRUEsT0FEUztRQUVsQkMsUUFBUSxFQUFFQSxRQUZRO1FBR2xCbUQsS0FBSyxFQUFFckMsQ0FIVztRQUlsQkcsT0FBTyxFQUFFQTtNQUpTLENBQXBCO01BT0EsS0FBS3RFLE1BQUwsQ0FBWW9HLE1BQVosQ0FBbUIsNEJBQWU5QixPQUFmLENBQW5CLEVBQTRDNkIsV0FBNUM7SUFDRDtFQUNGLENBZkQ7RUFpQkE7Ozs7Ozs7RUFLQWhELDJEQUE4QkMsT0FBOUIsRUFBdUNDLFFBQXZDLEVBQStDO0lBQzdDLElBQU1xRCxLQUFLLEdBQUdyRCxRQUFRLENBQUM2QyxjQUFULEVBQWQ7O0lBQ0EsS0FBSyxJQUFJWixDQUFDLEdBQUcsQ0FBUixFQUFXcUIsRUFBRSxHQUFHRCxLQUFLLENBQUNyQyxNQUEzQixFQUFtQ2lCLENBQUMsR0FBR3FCLEVBQXZDLEVBQTJDLEVBQUVyQixDQUE3QyxFQUFnRDtNQUM5QyxJQUFNVyxXQUFXLEdBQUdTLEtBQUssQ0FBQ3BCLENBQUQsQ0FBekI7O01BQ0EsS0FBSyxJQUFJbkIsQ0FBQyxHQUFHLENBQVIsRUFBV0MsRUFBRSxHQUFHNkIsV0FBVyxDQUFDNUIsTUFBWixHQUFxQixDQUExQyxFQUE2Q0YsQ0FBQyxHQUFHQyxFQUFqRCxFQUFxRCxFQUFFRCxDQUF2RCxFQUEwRDtRQUN4RCxJQUFNRyxPQUFPLEdBQUcyQixXQUFXLENBQUNRLEtBQVosQ0FBa0J0QyxDQUFsQixFQUFxQkEsQ0FBQyxHQUFHLENBQXpCLENBQWhCO1FBRUE7O1FBQ0EsSUFBTWdDLFdBQVcsR0FBRztVQUNsQi9DLE9BQU8sRUFBRUEsT0FEUztVQUVsQkMsUUFBUSxFQUFFQSxRQUZRO1VBR2xCa0QsS0FBSyxFQUFFLENBQUNqQixDQUFELENBSFc7VUFJbEJrQixLQUFLLEVBQUVyQyxDQUpXO1VBS2xCRyxPQUFPLEVBQUVBO1FBTFMsQ0FBcEI7UUFRQSxLQUFLdEUsTUFBTCxDQUFZb0csTUFBWixDQUFtQiw0QkFBZTlCLE9BQWYsQ0FBbkIsRUFBNEM2QixXQUE1QztNQUNEO0lBQ0Y7RUFDRixDQW5CRDtFQXFCQTs7Ozs7OztFQUtBaEQsbURBQXNCQyxPQUF0QixFQUErQkMsUUFBL0IsRUFBdUM7SUFDckMsSUFBTXVELEtBQUssR0FBR3ZELFFBQVEsQ0FBQzZDLGNBQVQsRUFBZDs7SUFDQSxLQUFLLElBQUlaLENBQUMsR0FBRyxDQUFSLEVBQVdxQixFQUFFLEdBQUdDLEtBQUssQ0FBQ3ZDLE1BQTNCLEVBQW1DaUIsQ0FBQyxHQUFHcUIsRUFBdkMsRUFBMkMsRUFBRXJCLENBQTdDLEVBQWdEO01BQzlDLElBQU1XLFdBQVcsR0FBR1csS0FBSyxDQUFDdEIsQ0FBRCxDQUF6Qjs7TUFDQSxLQUFLLElBQUluQixDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUc2QixXQUFXLENBQUM1QixNQUFaLEdBQXFCLENBQTFDLEVBQTZDRixDQUFDLEdBQUdDLEVBQWpELEVBQXFELEVBQUVELENBQXZELEVBQTBEO1FBQ3hELElBQU1HLE9BQU8sR0FBRzJCLFdBQVcsQ0FBQ1EsS0FBWixDQUFrQnRDLENBQWxCLEVBQXFCQSxDQUFDLEdBQUcsQ0FBekIsQ0FBaEI7UUFFQTs7UUFDQSxJQUFNZ0MsV0FBVyxHQUFHO1VBQ2xCL0MsT0FBTyxFQUFFQSxPQURTO1VBRWxCQyxRQUFRLEVBQUVBLFFBRlE7VUFHbEJrRCxLQUFLLEVBQUUsQ0FBQ2pCLENBQUQsQ0FIVztVQUlsQmtCLEtBQUssRUFBRXJDLENBSlc7VUFLbEJHLE9BQU8sRUFBRUE7UUFMUyxDQUFwQjtRQVFBLEtBQUt0RSxNQUFMLENBQVlvRyxNQUFaLENBQW1CLDRCQUFlOUIsT0FBZixDQUFuQixFQUE0QzZCLFdBQTVDO01BQ0Q7SUFDRjtFQUNGLENBbkJEO0VBcUJBOzs7Ozs7O0VBS0FoRCx3REFBMkJDLE9BQTNCLEVBQW9DQyxRQUFwQyxFQUE0QztJQUMxQyxJQUFNd0QsUUFBUSxHQUFHeEQsUUFBUSxDQUFDNkMsY0FBVCxFQUFqQjs7SUFDQSxLQUFLLElBQUlZLENBQUMsR0FBRyxDQUFSLEVBQVdDLEVBQUUsR0FBR0YsUUFBUSxDQUFDeEMsTUFBOUIsRUFBc0N5QyxDQUFDLEdBQUdDLEVBQTFDLEVBQThDLEVBQUVELENBQWhELEVBQW1EO01BQ2pELElBQU1GLEtBQUssR0FBR0MsUUFBUSxDQUFDQyxDQUFELENBQXRCOztNQUNBLEtBQUssSUFBSXhCLENBQUMsR0FBRyxDQUFSLEVBQVdxQixFQUFFLEdBQUdDLEtBQUssQ0FBQ3ZDLE1BQTNCLEVBQW1DaUIsQ0FBQyxHQUFHcUIsRUFBdkMsRUFBMkMsRUFBRXJCLENBQTdDLEVBQWdEO1FBQzlDLElBQU1XLFdBQVcsR0FBR1csS0FBSyxDQUFDdEIsQ0FBRCxDQUF6Qjs7UUFDQSxLQUFLLElBQUluQixDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUc2QixXQUFXLENBQUM1QixNQUFaLEdBQXFCLENBQTFDLEVBQTZDRixDQUFDLEdBQUdDLEVBQWpELEVBQXFELEVBQUVELENBQXZELEVBQTBEO1VBQ3hELElBQU1HLE9BQU8sR0FBRzJCLFdBQVcsQ0FBQ1EsS0FBWixDQUFrQnRDLENBQWxCLEVBQXFCQSxDQUFDLEdBQUcsQ0FBekIsQ0FBaEI7VUFFQTs7VUFDQSxJQUFNZ0MsV0FBVyxHQUFHO1lBQ2xCL0MsT0FBTyxFQUFFQSxPQURTO1lBRWxCQyxRQUFRLEVBQUVBLFFBRlE7WUFHbEJrRCxLQUFLLEVBQUUsQ0FBQ2pCLENBQUQsRUFBSXdCLENBQUosQ0FIVztZQUlsQk4sS0FBSyxFQUFFckMsQ0FKVztZQUtsQkcsT0FBTyxFQUFFQTtVQUxTLENBQXBCO1VBUUEsS0FBS3RFLE1BQUwsQ0FBWW9HLE1BQVosQ0FBbUIsNEJBQWU5QixPQUFmLENBQW5CLEVBQTRDNkIsV0FBNUM7UUFDRDtNQUNGO0lBQ0Y7RUFDRixDQXRCRDtFQXdCQTs7Ozs7Ozs7Ozs7OztFQVdBaEQsa0RBQXFCQyxPQUFyQixFQUE4QkMsUUFBOUIsRUFBc0M7SUFDcEMsSUFBTTRDLFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzJELFNBQVQsRUFBcEI7SUFFQTs7SUFDQSxJQUFNQyxpQkFBaUIsR0FBRztNQUN4QjdELE9BQU8sRUFBRUEsT0FEZTtNQUV4QkMsUUFBUSxFQUFFQSxRQUZjO01BR3hCbUQsS0FBSyxFQUFFM0ksbUJBSGlCO01BSXhCeUcsT0FBTyxFQUFFLENBQUMyQixXQUFELEVBQWNBLFdBQWQ7SUFKZSxDQUExQjtJQU9BOztJQUNBLElBQU1pQix3QkFBd0IsR0FBRztNQUMvQjlELE9BQU8sRUFBRUEsT0FEc0I7TUFFL0JDLFFBQVEsRUFBRUEsUUFGcUI7TUFHL0JtRCxLQUFLLEVBQUUxSSwwQkFId0I7TUFJL0J3RyxPQUFPLEVBQUUsQ0FBQzJCLFdBQUQsRUFBY0EsV0FBZDtJQUpzQixDQUFqQztJQU9BLElBQU1rQixlQUFlLEdBQUcsQ0FBQ0YsaUJBQUQsRUFBb0JDLHdCQUFwQixDQUF4QjtJQUNBRCxpQkFBaUIsQ0FBQ0UsZUFBbEIsR0FBb0NBLGVBQXBDO0lBQ0FELHdCQUF3QixDQUFDQyxlQUF6QixHQUEyQ0EsZUFBM0M7SUFDQSxLQUFLbkgsTUFBTCxDQUFZb0csTUFBWixDQUFtQiwwQ0FBYUgsV0FBYixDQUFuQixFQUE4Q2dCLGlCQUE5QztJQUNBLElBQUlHLGNBQWM7SUFBRztJQUNuQi9ELFFBREY7SUFHQSxJQUFNZ0UsY0FBYyxHQUFHLDhCQUF2Qjs7SUFDQSxJQUFJQSxjQUFjLElBQUksS0FBSzNELE1BQUwsRUFBdEIsRUFBcUM7TUFDbkMsSUFBTTRELFVBQVUsR0FBRyxLQUFLNUQsTUFBTCxHQUFjNkQsT0FBZCxHQUF3QkMsYUFBeEIsRUFBbkI7TUFDQUosY0FBYyxHQUFHQSxjQUFjLENBQzVCSyxLQURjLEdBRWRDLFNBRmMsQ0FFSkwsY0FGSSxFQUVZQyxVQUZaLENBQWpCO01BR0FGLGNBQWMsR0FBRztNQUNmO01BQW9EQSxjQURyQyxFQUVmTSxTQUZlLENBRUxKLFVBRkssRUFFT0QsY0FGUCxDQUFqQjtJQUdEOztJQUNELEtBQUtySCxNQUFMLENBQVlvRyxNQUFaLENBQW1CZ0IsY0FBYyxDQUFDZixTQUFmLEVBQW5CLEVBQStDYSx3QkFBL0M7RUFDRCxDQXJDRDtFQXVDQTs7Ozs7OztFQUtBL0QsOERBQWlDQyxPQUFqQyxFQUEwQ0MsUUFBMUMsRUFBa0Q7SUFDaEQsSUFBTXNFLFVBQVUsR0FBR3RFLFFBQVEsQ0FBQ3VFLGtCQUFULEVBQW5COztJQUNBLEtBQUssSUFBSXpELENBQUMsR0FBRyxDQUFiLEVBQWdCQSxDQUFDLEdBQUd3RCxVQUFVLENBQUN0RCxNQUEvQixFQUF1QyxFQUFFRixDQUF6QyxFQUE0QztNQUMxQyxJQUFNMEQsVUFBUSxHQUFHRixVQUFVLENBQUN4RCxDQUFELENBQTNCO01BQ0EsSUFBTVosTUFBTSxHQUFHLEtBQUtyQyxnQkFBTCxDQUFzQjJHLFVBQVEsQ0FBQ3JFLE9BQVQsRUFBdEIsQ0FBZjtNQUNBRCxNQUFNLENBQUNILE9BQUQsRUFBVXlFLFVBQVYsQ0FBTjtJQUNEO0VBQ0YsQ0FQRDtFQVNBOzs7Ozs7Ozs7RUFPQTFFLDBEQUE2QjhDLFdBQTdCLEVBQTBDM0gsUUFBMUMsRUFBb0RxSixVQUFwRCxFQUE4RDtJQUM1RCxJQUFJRyxhQUFhLEdBQUcsS0FBS25JLGNBQXpCOztJQUNBLElBQUksQ0FBQ21JLGFBQUwsRUFBb0I7TUFDbEJBLGFBQWEsR0FBRyxJQUFJQyxtQkFBSixDQUFZLElBQUlDLGlCQUFKLENBQVUvQixXQUFWLENBQVosQ0FBaEI7TUFDQSxLQUFLdEcsY0FBTCxHQUFzQm1JLGFBQXRCO01BQ0EsS0FBS3RILFFBQUwsQ0FBY3VFLFNBQWQsR0FBMEJrRCxVQUExQixDQUFxQ0gsYUFBckM7SUFDRCxDQUpELE1BSU87TUFDTCxJQUFNekUsUUFBUSxHQUFHeUUsYUFBYSxDQUFDeEUsV0FBZCxFQUFqQjtNQUNBRCxRQUFRLENBQUM2RSxjQUFULENBQXdCakMsV0FBeEI7SUFDRDs7SUFDRDZCLGFBQWEsQ0FBQ0ssR0FBZCxDQUFrQixVQUFsQixFQUE4QjdKLFFBQTlCO0lBQ0F3SixhQUFhLENBQUNLLEdBQWQsQ0FBa0IsWUFBbEIsRUFBZ0NSLFVBQWhDO0lBQ0EsT0FBT0csYUFBUDtFQUNELENBYkQ7RUFlQTs7Ozs7OztFQUtBM0UseUNBQVk1RSxlQUFaLEVBQTJCO0lBQ3pCLElBQUksQ0FBQ0EsZUFBZSxDQUFDNkosYUFBckIsRUFBb0M7TUFDbEMsT0FBTyxJQUFQO0lBQ0Q7O0lBQ0QsS0FBS3JGLGlCQUFMLEdBQXlCeEUsZUFBekI7SUFFQSxJQUFJOEosT0FBSjs7SUFDQSxJQUNFLENBQUM5SixlQUFlLENBQUNrRixHQUFoQixDQUFvQjhELE9BQXBCLEdBQThCZSxjQUE5QixFQUFELElBQ0EvSixlQUFlLENBQUNGLElBQWhCLElBQXdCa0ssZ0NBQW9CQyxXQUQ1QyxJQUVBLENBQUMsS0FBS0Msc0JBSFIsRUFJRTtNQUNBLEtBQUtDLGtCQUFMLENBQXdCbkssZUFBeEI7SUFDRDs7SUFDRCxJQUFJLEtBQUtvQixjQUFMLElBQXVCLEtBQUtMLGdCQUFMLENBQXNCZixlQUF0QixDQUEzQixFQUFtRTtNQUNqRSxJQUNFQSxlQUFlLENBQUNGLElBQWhCLElBQXdCa0ssZ0NBQW9CSSxXQUE1QyxJQUNBLENBQUMsS0FBSzdJLHNCQUZSLEVBR0U7UUFDQXVJLE9BQU8sR0FBRyxLQUFLTyxXQUFMLEVBQVY7TUFDRCxDQUxELE1BS087UUFDTFAsT0FBTyxHQUFHLElBQVY7TUFDRDtJQUNGOztJQUVELElBQUk5SixlQUFlLENBQUNGLElBQWhCLElBQXdCa0ssZ0NBQW9CSSxXQUFoRCxFQUE2RDtNQUMzRCxLQUFLN0ksc0JBQUwsR0FBOEIsS0FBOUI7SUFDRDs7SUFFRCxPQUFPdEIsaUJBQU1xSyxXQUFOLENBQWlCbEQsSUFBakIsQ0FBaUIsSUFBakIsRUFBa0JwSCxlQUFsQixLQUFzQyxDQUFDOEosT0FBOUM7RUFDRCxDQTlCRDtFQWdDQTs7Ozs7O0VBSUFsRiw2Q0FBZ0JhLEdBQWhCLEVBQW1CO0lBQ2pCLEtBQUtsRSxzQkFBTCxHQUE4QixLQUE5QjtJQUNBLEtBQUtnSixtQkFBTCxDQUF5QjlFLEdBQXpCLEVBQThCLEtBQUt6RCxhQUFuQztJQUVBLElBQU13SSxNQUFNLEdBQUcsQ0FDYi9FLEdBQUcsQ0FBQ2dGLFVBQUosQ0FBZSxDQUFmLElBQW9CLEtBQUtoRyxNQUFMLENBQVksQ0FBWixDQURQLEVBRWJnQixHQUFHLENBQUNnRixVQUFKLENBQWUsQ0FBZixJQUFvQixLQUFLaEcsTUFBTCxDQUFZLENBQVosQ0FGUCxDQUFmO0lBSUEsSUFBTTFFLFFBQVEsR0FBRyxFQUFqQjtJQUNBLElBQU1xSixVQUFVLEdBQUcsRUFBbkI7O0lBQ0EsS0FBSyxJQUFJeEQsQ0FBQyxHQUFHLENBQVIsRUFBV0MsRUFBRSxHQUFHLEtBQUs3RCxhQUFMLENBQW1COEQsTUFBeEMsRUFBZ0RGLENBQUMsR0FBR0MsRUFBcEQsRUFBd0QsRUFBRUQsQ0FBMUQsRUFBNkQ7TUFDM0QsSUFBTThFLFdBQVcsR0FBRyxLQUFLMUksYUFBTCxDQUFtQjRELENBQW5CLENBQXBCO01BQ0EsSUFBTWdDLFdBQVcsR0FBRzhDLFdBQVcsQ0FBQyxDQUFELENBQS9CO01BQ0EsSUFBTTdGLE9BQU8sR0FBRytDLFdBQVcsQ0FBQy9DLE9BQTVCOztNQUNBLElBQUk5RSxRQUFRLENBQUNtRyxPQUFULENBQWlCckIsT0FBakIsTUFBOEIsQ0FBQyxDQUFuQyxFQUFzQztRQUNwQzlFLFFBQVEsQ0FBQ29HLElBQVQsQ0FBY3RCLE9BQWQ7TUFDRDs7TUFDRCxJQUFNQyxRQUFRLEdBQUc4QyxXQUFXLENBQUM5QyxRQUE3Qjs7TUFDQSxJQUFJc0UsVUFBVSxDQUFDbEQsT0FBWCxDQUFtQnBCLFFBQW5CLE1BQWlDLENBQUMsQ0FBdEMsRUFBeUM7UUFDdkNzRSxVQUFVLENBQUNqRCxJQUFYLENBQWdCckIsUUFBaEI7TUFDRDs7TUFDRCxJQUFNa0QsS0FBSyxHQUFHSixXQUFXLENBQUNJLEtBQTFCO01BQ0EsSUFBSU4sV0FBVyxTQUFmO01BQ0EsSUFBTTNCLE9BQU8sR0FBRzZCLFdBQVcsQ0FBQzdCLE9BQTVCO01BQ0EsSUFBTWtDLEtBQUssR0FBR3lDLFdBQVcsQ0FBQyxDQUFELENBQXpCOztNQUVBLE9BQU9GLE1BQU0sQ0FBQzFFLE1BQVAsR0FBZ0JoQixRQUFRLENBQUM2RixTQUFULEVBQXZCLEVBQTZDO1FBQzNDSCxNQUFNLENBQUNyRSxJQUFQLENBQVlKLE9BQU8sQ0FBQ2tDLEtBQUQsQ0FBUCxDQUFldUMsTUFBTSxDQUFDMUUsTUFBdEIsQ0FBWjtNQUNEOztNQUVELFFBQVFoQixRQUFRLENBQUNHLE9BQVQsRUFBUjtRQUNFLEtBQUsyRix5QkFBYUMsS0FBbEI7VUFDRW5ELFdBQVcsR0FBRzhDLE1BQWQ7VUFDQXpFLE9BQU8sQ0FBQyxDQUFELENBQVAsR0FBYXlFLE1BQWI7VUFDQXpFLE9BQU8sQ0FBQyxDQUFELENBQVAsR0FBYXlFLE1BQWI7VUFDQTs7UUFDRixLQUFLSSx5QkFBYUUsV0FBbEI7VUFDRXBELFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzZDLGNBQVQsRUFBZDtVQUNBRCxXQUFXLENBQUNFLFdBQVcsQ0FBQ0ssS0FBYixDQUFYLEdBQWlDdUMsTUFBakM7VUFDQXpFLE9BQU8sQ0FBQyxDQUFELENBQVAsR0FBYXlFLE1BQWI7VUFDQXpFLE9BQU8sQ0FBQyxDQUFELENBQVAsR0FBYXlFLE1BQWI7VUFDQTs7UUFDRixLQUFLSSx5QkFBYUcsV0FBbEI7VUFDRXJELFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzZDLGNBQVQsRUFBZDtVQUNBRCxXQUFXLENBQUNFLFdBQVcsQ0FBQ0ssS0FBWixHQUFvQkEsS0FBckIsQ0FBWCxHQUF5Q3VDLE1BQXpDO1VBQ0F6RSxPQUFPLENBQUNrQyxLQUFELENBQVAsR0FBaUJ1QyxNQUFqQjtVQUNBOztRQUNGLEtBQUtJLHlCQUFhSSxpQkFBbEI7VUFDRXRELFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzZDLGNBQVQsRUFBZDtVQUNBRCxXQUFXLENBQUNNLEtBQUssQ0FBQyxDQUFELENBQU4sQ0FBWCxDQUFzQkosV0FBVyxDQUFDSyxLQUFaLEdBQW9CQSxLQUExQyxJQUFtRHVDLE1BQW5EO1VBQ0F6RSxPQUFPLENBQUNrQyxLQUFELENBQVAsR0FBaUJ1QyxNQUFqQjtVQUNBOztRQUNGLEtBQUtJLHlCQUFhSyxPQUFsQjtVQUNFdkQsV0FBVyxHQUFHNUMsUUFBUSxDQUFDNkMsY0FBVCxFQUFkO1VBQ0FELFdBQVcsQ0FBQ00sS0FBSyxDQUFDLENBQUQsQ0FBTixDQUFYLENBQXNCSixXQUFXLENBQUNLLEtBQVosR0FBb0JBLEtBQTFDLElBQW1EdUMsTUFBbkQ7VUFDQXpFLE9BQU8sQ0FBQ2tDLEtBQUQsQ0FBUCxHQUFpQnVDLE1BQWpCO1VBQ0E7O1FBQ0YsS0FBS0kseUJBQWFNLGFBQWxCO1VBQ0V4RCxXQUFXLEdBQUc1QyxRQUFRLENBQUM2QyxjQUFULEVBQWQ7VUFDQUQsV0FBVyxDQUFDTSxLQUFLLENBQUMsQ0FBRCxDQUFOLENBQVgsQ0FBc0JBLEtBQUssQ0FBQyxDQUFELENBQTNCLEVBQWdDSixXQUFXLENBQUNLLEtBQVosR0FBb0JBLEtBQXBELElBQTZEdUMsTUFBN0Q7VUFDQXpFLE9BQU8sQ0FBQ2tDLEtBQUQsQ0FBUCxHQUFpQnVDLE1BQWpCO1VBQ0E7O1FBQ0YsS0FBS0kseUJBQWFPLE1BQWxCO1VBQ0VwRixPQUFPLENBQUMsQ0FBRCxDQUFQLEdBQWF5RSxNQUFiO1VBQ0F6RSxPQUFPLENBQUMsQ0FBRCxDQUFQLEdBQWF5RSxNQUFiOztVQUNBLElBQUk1QyxXQUFXLENBQUNLLEtBQVosS0FBc0IzSSxtQkFBMUIsRUFBK0M7WUFDN0MsS0FBS3lDLGdCQUFMLEdBQXdCLElBQXhCO1lBQ0ErQyxRQUFRLENBQUNzRyxTQUFULENBQW1CWixNQUFuQjtZQUNBLEtBQUt6SSxnQkFBTCxHQUF3QixLQUF4QjtVQUNELENBSkQsTUFJTztZQUNMO1lBQ0EsS0FBS0EsZ0JBQUwsR0FBd0IsSUFBeEI7WUFDQSxJQUFNZ0gsVUFBVSxHQUFHdEQsR0FBRyxDQUFDUCxHQUFKLENBQVE4RCxPQUFSLEdBQWtCQyxhQUFsQixFQUFuQjtZQUNBLElBQUlvQyxNQUFNLEdBQUcsMEJBQ1gsOEJBQW1CdkcsUUFBUSxDQUFDMkQsU0FBVCxFQUFuQixFQUF5Q00sVUFBekMsQ0FEVyxFQUVYLDhCQUFtQnlCLE1BQW5CLEVBQTJCekIsVUFBM0IsQ0FGVyxDQUFiO1lBSUEsSUFBTUQsY0FBYyxHQUFHLDhCQUF2Qjs7WUFDQSxJQUFJQSxjQUFKLEVBQW9CO2NBQ2xCLElBQU1ELGNBQWMsR0FBRy9ELFFBQVEsQ0FDNUJvRSxLQURvQixHQUVwQkMsU0FGb0IsQ0FFVkwsY0FGVSxFQUVNQyxVQUZOLENBQXZCO2NBR0FGLGNBQWMsQ0FBQ3lDLFNBQWYsQ0FBeUJELE1BQXpCO2NBQ0FBLE1BQU0sR0FBR3hDLGNBQWMsQ0FDcEJNLFNBRE0sQ0FDSUosVUFESixFQUNnQkQsY0FEaEIsRUFFTnlDLFNBRk0sRUFBVDtZQUdEOztZQUNEekcsUUFBUSxDQUFDd0csU0FBVCxDQUFtQkQsTUFBbkI7WUFDQSxLQUFLdEosZ0JBQUwsR0FBd0IsS0FBeEI7VUFDRDs7VUFDRDs7UUFDRixRQTdERixDQThERTs7TUE5REY7O01BaUVBLElBQUkyRixXQUFKLEVBQWlCO1FBQ2YsS0FBSzhELHVCQUFMLENBQTZCMUcsUUFBN0IsRUFBdUM0QyxXQUF2QztNQUNEO0lBQ0Y7O0lBQ0QsS0FBSytELDRCQUFMLENBQWtDakIsTUFBbEMsRUFBMEN6SyxRQUExQyxFQUFvRHFKLFVBQXBEO0VBQ0QsQ0FwR0Q7RUFzR0E7Ozs7Ozs7RUFLQXhFLDZDQUFnQmEsR0FBaEIsRUFBbUI7SUFDakIsSUFBSSxDQUFDLEtBQUs5RSxVQUFMLENBQWdCOEUsR0FBaEIsQ0FBTCxFQUEyQjtNQUN6QixPQUFPLEtBQVA7SUFDRDs7SUFDRCxJQUFNaUcsZUFBZSxHQUFHakcsR0FBRyxDQUFDZ0YsVUFBNUI7SUFDQSxLQUFLbkYscUJBQUwsQ0FBMkJHLEdBQUcsQ0FBQ2tHLEtBQS9CLEVBQXNDbEcsR0FBRyxDQUFDUCxHQUExQyxFQUErQ3dHLGVBQS9DO0lBQ0EsS0FBSzFKLGFBQUwsQ0FBbUI4RCxNQUFuQixHQUE0QixDQUE1QjtJQUNBLEtBQUt0RSxzQkFBTCxHQUE4QixJQUE5QjtJQUNBLElBQU0rSCxhQUFhLEdBQUcsS0FBS25JLGNBQTNCOztJQUNBLElBQUltSSxhQUFKLEVBQW1CO01BQ2pCLElBQU1SLFVBQVUsR0FBR3RELEdBQUcsQ0FBQ1AsR0FBSixDQUFROEQsT0FBUixHQUFrQkMsYUFBbEIsRUFBbkI7TUFDQSxJQUFNMkMsY0FBYyxHQUFHLEVBQXZCO01BQ0EsSUFBTXBCLE1BQU0sR0FBR2pCLGFBQWEsQ0FBQ3hFLFdBQWQsR0FBNEI0QyxjQUE1QixFQUFmO01BQ0EsSUFBTWtFLFlBQVksR0FBRyw0QkFBZSxDQUFDckIsTUFBRCxDQUFmLENBQXJCO01BQ0EsSUFBTXNCLGtCQUFrQixHQUFHLEtBQUtySyxNQUFMLENBQVlzSyxXQUFaLENBQXdCRixZQUF4QixDQUEzQjtNQUNBLElBQU1HLGlCQUFpQixHQUFHLEVBQTFCO01BQ0FGLGtCQUFrQixDQUFDRyxJQUFuQixDQUF3QkMsY0FBeEI7O01BQ0EsS0FBSyxJQUFJdEcsQ0FBQyxHQUFHLENBQVIsRUFBV0MsRUFBRSxHQUFHaUcsa0JBQWtCLENBQUNoRyxNQUF4QyxFQUFnREYsQ0FBQyxHQUFHQyxFQUFwRCxFQUF3RCxFQUFFRCxDQUExRCxFQUE2RDtRQUMzRCxJQUFNdUcsZ0JBQWdCLEdBQUdMLGtCQUFrQixDQUFDbEcsQ0FBRCxDQUEzQztRQUNBLElBQU1HLE9BQU8sR0FBR29HLGdCQUFnQixDQUFDcEcsT0FBakM7UUFDQSxJQUFJcUcsR0FBRyxHQUFHLGtCQUFPRCxnQkFBZ0IsQ0FBQ3JILFFBQXhCLENBQVY7UUFDQSxJQUFNa0QsS0FBSyxHQUFHbUUsZ0JBQWdCLENBQUNuRSxLQUEvQjs7UUFDQSxJQUFJQSxLQUFKLEVBQVc7VUFDVG9FLEdBQUcsSUFBSSxNQUFNcEUsS0FBSyxDQUFDcUUsSUFBTixDQUFXLEdBQVgsQ0FBYixDQURTLENBQ3FCO1FBQy9COztRQUNELElBQUksQ0FBQ0wsaUJBQWlCLENBQUNJLEdBQUQsQ0FBdEIsRUFBNkI7VUFDM0JKLGlCQUFpQixDQUFDSSxHQUFELENBQWpCLEdBQXlCLElBQUlFLEtBQUosQ0FBVSxDQUFWLENBQXpCO1FBQ0Q7O1FBRUQsSUFDRUgsZ0JBQWdCLENBQUNySCxRQUFqQixDQUEwQkcsT0FBMUIsT0FBd0MyRix5QkFBYU8sTUFBckQsSUFDQWdCLGdCQUFnQixDQUFDbEUsS0FBakIsS0FBMkIxSSwwQkFGN0IsRUFHRTtVQUNBLElBQU1nTixhQUFhLEdBQUdDLG9CQUFvQixDQUN4Q2QsZUFEd0MsRUFFeENTLGdCQUZ3QyxFQUd4Q3BELFVBSHdDLENBQTFDOztVQUtBLElBQ0Usd0JBQWlCd0QsYUFBakIsRUFBZ0MvQixNQUFoQyxLQUNBLENBQUN3QixpQkFBaUIsQ0FBQ0ksR0FBRCxDQUFqQixDQUF1QixDQUF2QixDQUZILEVBR0U7WUFDQSxLQUFLcEssYUFBTCxDQUFtQm1FLElBQW5CLENBQXdCLENBQUNnRyxnQkFBRCxFQUFtQixDQUFuQixDQUF4QjtZQUNBSCxpQkFBaUIsQ0FBQ0ksR0FBRCxDQUFqQixDQUF1QixDQUF2QixJQUE0QkQsZ0JBQTVCO1VBQ0Q7O1VBQ0Q7UUFDRDs7UUFFRCxJQUNFLHdCQUFpQnBHLE9BQU8sQ0FBQyxDQUFELENBQXhCLEVBQTZCeUUsTUFBN0IsS0FDQSxDQUFDd0IsaUJBQWlCLENBQUNJLEdBQUQsQ0FBakIsQ0FBdUIsQ0FBdkIsQ0FGSCxFQUdFO1VBQ0EsS0FBS3BLLGFBQUwsQ0FBbUJtRSxJQUFuQixDQUF3QixDQUFDZ0csZ0JBQUQsRUFBbUIsQ0FBbkIsQ0FBeEI7VUFDQUgsaUJBQWlCLENBQUNJLEdBQUQsQ0FBakIsQ0FBdUIsQ0FBdkIsSUFBNEJELGdCQUE1QjtVQUNBO1FBQ0Q7O1FBRUQsSUFDRSx3QkFBaUJwRyxPQUFPLENBQUMsQ0FBRCxDQUF4QixFQUE2QnlFLE1BQTdCLEtBQ0EsQ0FBQ3dCLGlCQUFpQixDQUFDSSxHQUFELENBQWpCLENBQXVCLENBQXZCLENBRkgsRUFHRTtVQUNBO1VBQ0EsSUFDRSxDQUFDRCxnQkFBZ0IsQ0FBQ3JILFFBQWpCLENBQTBCRyxPQUExQixPQUF3QzJGLHlCQUFhRyxXQUFyRCxJQUNDb0IsZ0JBQWdCLENBQUNySCxRQUFqQixDQUEwQkcsT0FBMUIsT0FDRTJGLHlCQUFhSSxpQkFGakIsS0FHQWdCLGlCQUFpQixDQUFDSSxHQUFELENBQWpCLENBQXVCLENBQXZCLENBSEEsSUFJQUosaUJBQWlCLENBQUNJLEdBQUQsQ0FBakIsQ0FBdUIsQ0FBdkIsRUFBMEJuRSxLQUExQixLQUFvQyxDQUx0QyxFQU1FO1lBQ0E7VUFDRDs7VUFFRCxLQUFLakcsYUFBTCxDQUFtQm1FLElBQW5CLENBQXdCLENBQUNnRyxnQkFBRCxFQUFtQixDQUFuQixDQUF4QjtVQUNBSCxpQkFBaUIsQ0FBQ0ksR0FBRCxDQUFqQixDQUF1QixDQUF2QixJQUE0QkQsZ0JBQTVCO1VBQ0E7UUFDRDs7UUFFRCxJQUNFLGtCQUFPcEcsT0FBUCxLQUFtQixLQUFLMUUsZUFBeEIsSUFDQSxDQUFDMkssaUJBQWlCLENBQUNJLEdBQUQsQ0FBakIsQ0FBdUIsQ0FBdkIsQ0FERCxJQUVBLENBQUNKLGlCQUFpQixDQUFDSSxHQUFELENBQWpCLENBQXVCLENBQXZCLENBRkQsSUFHQSxLQUFLbkwsc0JBQUwsQ0FBNEJ3RSxHQUE1QixDQUpGLEVBS0U7VUFDQW1HLGNBQWMsQ0FBQ3pGLElBQWYsQ0FBb0JnRyxnQkFBcEI7UUFDRDtNQUNGOztNQUVELElBQUlQLGNBQWMsQ0FBQzlGLE1BQW5CLEVBQTJCO1FBQ3pCLEtBQUt5RSxtQkFBTCxDQUF5QjlFLEdBQXpCLEVBQThCLENBQUNtRyxjQUFELENBQTlCO01BQ0Q7O01BRUQsS0FBSyxJQUFJN0UsQ0FBQyxHQUFHNkUsY0FBYyxDQUFDOUYsTUFBZixHQUF3QixDQUFyQyxFQUF3Q2lCLENBQUMsSUFBSSxDQUE3QyxFQUFnRCxFQUFFQSxDQUFsRCxFQUFxRDtRQUNuRCxLQUFLMEYsYUFBTCxDQUFtQmIsY0FBYyxDQUFDN0UsQ0FBRCxDQUFqQyxFQUFzQ3lELE1BQXRDO01BQ0Q7SUFDRjs7SUFDRCxPQUFPLENBQUMsQ0FBQyxLQUFLcEosY0FBZDtFQUNELENBaEdEO0VBa0dBOzs7Ozs7O0VBS0F3RCwyQ0FBY2EsR0FBZCxFQUFpQjtJQUNmLEtBQUssSUFBSUcsQ0FBQyxHQUFHLEtBQUs1RCxhQUFMLENBQW1COEQsTUFBbkIsR0FBNEIsQ0FBekMsRUFBNENGLENBQUMsSUFBSSxDQUFqRCxFQUFvRCxFQUFFQSxDQUF0RCxFQUF5RDtNQUN2RCxJQUFNZ0MsV0FBVyxHQUFHLEtBQUs1RixhQUFMLENBQW1CNEQsQ0FBbkIsRUFBc0IsQ0FBdEIsQ0FBcEI7TUFDQSxJQUFNZCxRQUFRLEdBQUc4QyxXQUFXLENBQUM5QyxRQUE3Qjs7TUFDQSxJQUFJQSxRQUFRLENBQUNHLE9BQVQsT0FBdUIyRix5QkFBYU8sTUFBeEMsRUFBZ0Q7UUFDOUM7UUFDQSxJQUFNekQsV0FBVyxHQUFHNUMsUUFBUSxDQUFDMkQsU0FBVCxFQUFwQjtRQUNBLElBQU1DLGlCQUFpQixHQUFHZCxXQUFXLENBQUNnQixlQUFaLENBQTRCLENBQTVCLENBQTFCO1FBQ0EsSUFBTUQsd0JBQXdCLEdBQUdmLFdBQVcsQ0FBQ2dCLGVBQVosQ0FBNEIsQ0FBNUIsQ0FBakM7UUFDQUYsaUJBQWlCLENBQUMzQyxPQUFsQixDQUEwQixDQUExQixJQUErQjJCLFdBQS9CO1FBQ0FnQixpQkFBaUIsQ0FBQzNDLE9BQWxCLENBQTBCLENBQTFCLElBQStCMkIsV0FBL0I7UUFDQWlCLHdCQUF3QixDQUFDNUMsT0FBekIsQ0FBaUMsQ0FBakMsSUFBc0MyQixXQUF0QztRQUNBaUIsd0JBQXdCLENBQUM1QyxPQUF6QixDQUFpQyxDQUFqQyxJQUFzQzJCLFdBQXRDO1FBQ0EsS0FBS2pHLE1BQUwsQ0FBWWlMLE1BQVosQ0FBbUIsMENBQWFoRixXQUFiLENBQW5CLEVBQThDZ0IsaUJBQTlDO1FBQ0EsSUFBSUcsY0FBYyxHQUFHL0QsUUFBckI7UUFDQSxJQUFNZ0UsY0FBYyxHQUFHLDhCQUF2Qjs7UUFDQSxJQUFJQSxjQUFKLEVBQW9CO1VBQ2xCLElBQU1DLFVBQVUsR0FBR3RELEdBQUcsQ0FBQ1AsR0FBSixDQUFROEQsT0FBUixHQUFrQkMsYUFBbEIsRUFBbkI7VUFDQUosY0FBYyxHQUFHQSxjQUFjLENBQzVCSyxLQURjLEdBRWRDLFNBRmMsQ0FFSkwsY0FGSSxFQUVZQyxVQUZaLENBQWpCO1VBR0FGLGNBQWMsR0FBRyx5QkFBV0EsY0FBWCxFQUEyQk0sU0FBM0IsQ0FDZkosVUFEZSxFQUVmRCxjQUZlLENBQWpCO1FBSUQ7O1FBQ0QsS0FBS3JILE1BQUwsQ0FBWWlMLE1BQVosQ0FDRTdELGNBQWMsQ0FBQ2YsU0FBZixFQURGLEVBRUVhLHdCQUZGO01BSUQsQ0ExQkQsTUEwQk87UUFDTCxLQUFLbEgsTUFBTCxDQUFZaUwsTUFBWixDQUFtQiw0QkFBZTlFLFdBQVcsQ0FBQzdCLE9BQTNCLENBQW5CLEVBQXdENkIsV0FBeEQ7TUFDRDtJQUNGOztJQUNELElBQUksS0FBS3BHLHNCQUFULEVBQWlDO01BQy9CLEtBQUs2RSxhQUFMLENBQ0UsSUFBSUMsV0FBSixDQUNFNUcsZUFBZSxDQUFDRSxTQURsQixFQUVFLEtBQUs0QixzQkFGUCxFQUdFaUUsR0FIRixDQURGO01BT0EsS0FBS2pFLHNCQUFMLEdBQThCLElBQTlCO0lBQ0Q7O0lBQ0QsT0FBTyxLQUFQO0VBQ0QsQ0E3Q0Q7RUErQ0E7Ozs7OztFQUlBb0QsZ0RBQW1CYSxHQUFuQixFQUFzQjtJQUNwQixLQUFLbkUsVUFBTCxHQUFrQm1FLEdBQUcsQ0FBQ2tHLEtBQXRCO0lBQ0EsS0FBS3JHLHFCQUFMLENBQTJCRyxHQUFHLENBQUNrRyxLQUEvQixFQUFzQ2xHLEdBQUcsQ0FBQ1AsR0FBMUMsRUFBK0NPLEdBQUcsQ0FBQ2dGLFVBQW5EO0VBQ0QsQ0FIRDtFQUtBOzs7Ozs7OztFQU1BN0YsbURBQXNCK0csS0FBdEIsRUFBNkJ6RyxHQUE3QixFQUFrQ3lILGNBQWxDLEVBQWdEO0lBQWhEOztJQUNFLElBQU1qQixlQUFlLEdBQUdpQixjQUFjLElBQUl6SCxHQUFHLENBQUMwSCxzQkFBSixDQUEyQmpCLEtBQTNCLENBQTFDO0lBQ0EsSUFBTTVDLFVBQVUsR0FBRzdELEdBQUcsQ0FBQzhELE9BQUosR0FBY0MsYUFBZCxFQUFuQjs7SUFDQSxJQUFNNEQsY0FBYyxHQUFHLFNBQWpCQSxjQUFpQixDQUFVQyxDQUFWLEVBQWFDLENBQWIsRUFBYztNQUNuQyxPQUNFQyxxQ0FBcUMsQ0FBQ3RCLGVBQUQsRUFBa0JvQixDQUFsQixFQUFxQi9ELFVBQXJCLENBQXJDLEdBQ0FpRSxxQ0FBcUMsQ0FBQ3RCLGVBQUQsRUFBa0JxQixDQUFsQixFQUFxQmhFLFVBQXJCLENBRnZDO0lBSUQsQ0FMRDtJQU9BOzs7SUFDQSxJQUFJa0UsS0FBSjtJQUNBLElBQUlDLGdCQUFKOztJQUNBLElBQUksS0FBSzdKLGFBQVQsRUFBd0I7TUFDdEIsSUFBTThKLFdBQVcsR0FDZixRQUFPLEtBQUs5SixhQUFaLE1BQThCLFFBQTlCLEdBQ0ksVUFBQytKLEtBQUQsRUFBTTtRQUFLLFlBQUssS0FBS2xOLEtBQUksQ0FBQ21ELGFBQWY7TUFBNEIsQ0FEM0MsR0FFSXhCLFNBSE47TUFJQXFELEdBQUcsQ0FBQ21JLHFCQUFKLENBQ0UxQixLQURGLEVBRUUsVUFBQzlHLE9BQUQsRUFBVXVJLEtBQVYsRUFBaUJ0SSxRQUFqQixFQUF5QjtRQUN2QkEsUUFBUSxHQUNOQSxRQUFRO1FBQ1I7UUFDRUQsT0FBTyxDQUFDRSxXQUFSLEVBSEo7O1FBS0EsSUFDRUQsUUFBUSxDQUFDRyxPQUFULE9BQXVCMkYseUJBQWFDLEtBQXBDLElBQ0EscUJBQVMzSyxLQUFJLENBQUM4RCxTQUFMLENBQWUyQixRQUFmLEVBQVQsRUFBb0NkLE9BQXBDLENBRkYsRUFHRTtVQUNBcUksZ0JBQWdCLEdBQUdwSSxRQUFuQjtVQUNBLElBQU0yRixVQUFVLEdBQUczRixRQUFRLENBQUN3SSxrQkFBVCxHQUE4QnBGLEtBQTlCLENBQW9DLENBQXBDLEVBQXVDLENBQXZDLENBQW5CO1VBQ0ErRSxLQUFLLEdBQUcsQ0FDTjtZQUNFcEksT0FBTyxTQURUO1lBRUVDLFFBQVEsVUFGVjtZQUdFaUIsT0FBTyxFQUFFLENBQUMwRSxVQUFELEVBQWFBLFVBQWI7VUFIWCxDQURNLENBQVI7UUFPRDs7UUFDRCxPQUFPLElBQVA7TUFDRCxDQXZCSCxFQXdCRTtRQUFDMEMsV0FBVztNQUFaLENBeEJGO0lBMEJEOztJQUNELElBQUksQ0FBQ0YsS0FBTCxFQUFZO01BQ1YsSUFBTU0sVUFBVSxHQUFHLDBCQUNqQiwwQ0FBYTdCLGVBQWIsRUFBOEJsTSxVQUE5QixDQURpQixFQUVqQnVKLFVBRmlCLENBQW5CO01BSUEsSUFBTXlFLE1BQU0sR0FBR3RJLEdBQUcsQ0FBQzhELE9BQUosR0FBY3lFLGFBQWQsS0FBZ0MsS0FBSzlMLGVBQXBEO01BQ0EsSUFBTStMLEdBQUcsR0FBRyx3QkFDVixvQkFBYUgsVUFBYixFQUF5QkMsTUFBekIsRUFBaUNoTyxVQUFqQyxDQURVLEVBRVZ1SixVQUZVLENBQVo7TUFJQWtFLEtBQUssR0FBRyxLQUFLeEwsTUFBTCxDQUFZc0ssV0FBWixDQUF3QjJCLEdBQXhCLENBQVI7SUFDRDs7SUFFRCxJQUFJVCxLQUFLLElBQUlBLEtBQUssQ0FBQ25ILE1BQU4sR0FBZSxDQUE1QixFQUErQjtNQUM3QixJQUFNZSxJQUFJLEdBQUdvRyxLQUFLLENBQUNoQixJQUFOLENBQVdZLGNBQVgsRUFBMkIsQ0FBM0IsQ0FBYjtNQUNBLElBQU1jLGNBQWMsR0FBRzlHLElBQUksQ0FBQ2QsT0FBNUI7TUFDQSxJQUFJeUUsTUFBTSxHQUFHZ0Msb0JBQW9CLENBQUNkLGVBQUQsRUFBa0I3RSxJQUFsQixFQUF3QmtDLFVBQXhCLENBQWpDO01BQ0EsSUFBTTZFLFdBQVcsR0FBRzFJLEdBQUcsQ0FBQzJJLHNCQUFKLENBQTJCckQsTUFBM0IsQ0FBcEI7TUFDQSxJQUFJc0QsSUFBSSxHQUFHLDBCQUFtQm5DLEtBQW5CLEVBQTBCaUMsV0FBMUIsQ0FBWDs7TUFDQSxJQUFJVixnQkFBZ0IsSUFBSVksSUFBSSxJQUFJLEtBQUtuTSxlQUFyQyxFQUFzRDtRQUNwRDtRQUNBLElBQU1vTSxjQUFjLEdBQUcsRUFBdkI7UUFDQUEsY0FBYyxDQUFDLGtCQUFPSixjQUFQLENBQUQsQ0FBZCxHQUF5QyxJQUF6Qzs7UUFFQSxJQUFJLENBQUMsS0FBS2pKLGNBQVYsRUFBMEI7VUFDeEIsS0FBS0QsTUFBTCxDQUFZLENBQVosSUFBaUIrRixNQUFNLENBQUMsQ0FBRCxDQUFOLEdBQVlrQixlQUFlLENBQUMsQ0FBRCxDQUE1QztVQUNBLEtBQUtqSCxNQUFMLENBQVksQ0FBWixJQUFpQitGLE1BQU0sQ0FBQyxDQUFELENBQU4sR0FBWWtCLGVBQWUsQ0FBQyxDQUFELENBQTVDO1FBQ0Q7O1FBQ0QsSUFDRTdFLElBQUksQ0FBQy9CLFFBQUwsQ0FBY0csT0FBZCxPQUE0QjJGLHlCQUFhTyxNQUF6QyxJQUNBdEUsSUFBSSxDQUFDb0IsS0FBTCxLQUFlMUksMEJBRmpCLEVBR0U7VUFDQSxLQUFLdUMsZ0JBQUwsR0FBd0IsSUFBeEI7VUFDQSxLQUFLMkosNEJBQUwsQ0FDRWpCLE1BREYsRUFFRSxDQUFDM0QsSUFBSSxDQUFDaEMsT0FBTixDQUZGLEVBR0UsQ0FBQ2dDLElBQUksQ0FBQy9CLFFBQU4sQ0FIRjtRQUtELENBVkQsTUFVTztVQUNMLElBQU1rSixNQUFNLEdBQUc5SSxHQUFHLENBQUMySSxzQkFBSixDQUEyQkYsY0FBYyxDQUFDLENBQUQsQ0FBekMsQ0FBZjtVQUNBLElBQU1NLE1BQU0sR0FBRy9JLEdBQUcsQ0FBQzJJLHNCQUFKLENBQTJCRixjQUFjLENBQUMsQ0FBRCxDQUF6QyxDQUFmO1VBQ0EsSUFBTU8sWUFBWSxHQUFHLGlDQUEwQk4sV0FBMUIsRUFBdUNJLE1BQXZDLENBQXJCO1VBQ0EsSUFBTUcsWUFBWSxHQUFHLGlDQUEwQlAsV0FBMUIsRUFBdUNLLE1BQXZDLENBQXJCO1VBQ0FILElBQUksR0FBR00sSUFBSSxDQUFDQyxJQUFMLENBQVVELElBQUksQ0FBQ0UsR0FBTCxDQUFTSixZQUFULEVBQXVCQyxZQUF2QixDQUFWLENBQVA7VUFDQSxLQUFLck0sZ0JBQUwsR0FBd0JnTSxJQUFJLElBQUksS0FBS25NLGVBQXJDOztVQUNBLElBQUksS0FBS0csZ0JBQVQsRUFBMkI7WUFDekIwSSxNQUFNLEdBQ0owRCxZQUFZLEdBQUdDLFlBQWYsR0FDSVIsY0FBYyxDQUFDLENBQUQsQ0FEbEIsR0FFSUEsY0FBYyxDQUFDLENBQUQsQ0FIcEI7VUFJRDs7VUFDRCxLQUFLbEMsNEJBQUwsQ0FDRWpCLE1BREYsRUFFRSxDQUFDM0QsSUFBSSxDQUFDaEMsT0FBTixDQUZGLEVBR0UsQ0FBQ2dDLElBQUksQ0FBQy9CLFFBQU4sQ0FIRjtVQUtBLElBQU1zRSxVQUFVLEdBQUcsRUFBbkI7VUFDQUEsVUFBVSxDQUFDLGtCQUFPdkMsSUFBSSxDQUFDL0IsUUFBWixDQUFELENBQVYsR0FBb0MsSUFBcEM7O1VBQ0EsS0FBSyxJQUFJYyxDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUdvSCxLQUFLLENBQUNuSCxNQUEzQixFQUFtQ0YsQ0FBQyxHQUFHQyxFQUF2QyxFQUEyQyxFQUFFRCxDQUE3QyxFQUFnRDtZQUM5QyxJQUFNRyxPQUFPLEdBQUdrSCxLQUFLLENBQUNySCxDQUFELENBQUwsQ0FBU0csT0FBekI7O1lBQ0EsSUFDRyx3QkFBaUI0SCxjQUFjLENBQUMsQ0FBRCxDQUEvQixFQUFvQzVILE9BQU8sQ0FBQyxDQUFELENBQTNDLEtBQ0Msd0JBQWlCNEgsY0FBYyxDQUFDLENBQUQsQ0FBL0IsRUFBb0M1SCxPQUFPLENBQUMsQ0FBRCxDQUEzQyxDQURGLElBRUMsd0JBQWlCNEgsY0FBYyxDQUFDLENBQUQsQ0FBL0IsRUFBb0M1SCxPQUFPLENBQUMsQ0FBRCxDQUEzQyxLQUNDLHdCQUFpQjRILGNBQWMsQ0FBQyxDQUFELENBQS9CLEVBQW9DNUgsT0FBTyxDQUFDLENBQUQsQ0FBM0MsQ0FKSixFQUtFO2NBQ0EsSUFBTXdJLFdBQVcsR0FBRyxrQkFBT3RCLEtBQUssQ0FBQ3JILENBQUQsQ0FBTCxDQUFTZCxRQUFoQixDQUFwQjs7Y0FDQSxJQUFJLEVBQUV5SixXQUFXLElBQUluRixVQUFqQixDQUFKLEVBQWtDO2dCQUNoQ0EsVUFBVSxDQUFDbUYsV0FBRCxDQUFWLEdBQTBCLElBQTFCO2dCQUNBUixjQUFjLENBQUMsa0JBQU9oSSxPQUFQLENBQUQsQ0FBZCxHQUFrQyxJQUFsQztjQUNEO1lBQ0YsQ0FYRCxNQVdPO2NBQ0w7WUFDRDtVQUNGO1FBQ0Y7O1FBRUQsS0FBSzFFLGVBQUwsR0FBdUIwTSxjQUF2QjtRQUNBO01BQ0Q7SUFDRjs7SUFDRCxJQUFJLEtBQUszTSxjQUFULEVBQXlCO01BQ3ZCLEtBQUthLFFBQUwsQ0FBY3VFLFNBQWQsR0FBMEJDLGFBQTFCLENBQXdDLEtBQUtyRixjQUE3QztNQUNBLEtBQUtBLGNBQUwsR0FBc0IsSUFBdEI7SUFDRDtFQUNGLENBbElEO0VBb0lBOzs7Ozs7O0VBS0F3RCwyQ0FBY2dELFdBQWQsRUFBMkI0QyxNQUEzQixFQUFpQztJQUMvQixJQUFNekUsT0FBTyxHQUFHNkIsV0FBVyxDQUFDN0IsT0FBNUI7SUFDQSxJQUFNbEIsT0FBTyxHQUFHK0MsV0FBVyxDQUFDL0MsT0FBNUI7SUFDQSxJQUFNQyxRQUFRLEdBQUc4QyxXQUFXLENBQUM5QyxRQUE3QjtJQUNBLElBQU1rRCxLQUFLLEdBQUdKLFdBQVcsQ0FBQ0ksS0FBMUI7SUFDQSxJQUFNQyxLQUFLLEdBQUdMLFdBQVcsQ0FBQ0ssS0FBMUI7SUFDQSxJQUFJUCxXQUFKOztJQUVBLE9BQU84QyxNQUFNLENBQUMxRSxNQUFQLEdBQWdCaEIsUUFBUSxDQUFDNkYsU0FBVCxFQUF2QixFQUE2QztNQUMzQ0gsTUFBTSxDQUFDckUsSUFBUCxDQUFZLENBQVo7SUFDRDs7SUFFRCxRQUFRckIsUUFBUSxDQUFDRyxPQUFULEVBQVI7TUFDRSxLQUFLMkYseUJBQWFJLGlCQUFsQjtRQUNFdEQsV0FBVyxHQUFHNUMsUUFBUSxDQUFDNkMsY0FBVCxFQUFkO1FBQ0FELFdBQVcsQ0FBQ00sS0FBSyxDQUFDLENBQUQsQ0FBTixDQUFYLENBQXNCaEIsTUFBdEIsQ0FBNkJpQixLQUFLLEdBQUcsQ0FBckMsRUFBd0MsQ0FBeEMsRUFBMkN1QyxNQUEzQztRQUNBOztNQUNGLEtBQUtJLHlCQUFhSyxPQUFsQjtRQUNFdkQsV0FBVyxHQUFHNUMsUUFBUSxDQUFDNkMsY0FBVCxFQUFkO1FBQ0FELFdBQVcsQ0FBQ00sS0FBSyxDQUFDLENBQUQsQ0FBTixDQUFYLENBQXNCaEIsTUFBdEIsQ0FBNkJpQixLQUFLLEdBQUcsQ0FBckMsRUFBd0MsQ0FBeEMsRUFBMkN1QyxNQUEzQztRQUNBOztNQUNGLEtBQUtJLHlCQUFhTSxhQUFsQjtRQUNFeEQsV0FBVyxHQUFHNUMsUUFBUSxDQUFDNkMsY0FBVCxFQUFkO1FBQ0FELFdBQVcsQ0FBQ00sS0FBSyxDQUFDLENBQUQsQ0FBTixDQUFYLENBQXNCQSxLQUFLLENBQUMsQ0FBRCxDQUEzQixFQUFnQ2hCLE1BQWhDLENBQXVDaUIsS0FBSyxHQUFHLENBQS9DLEVBQWtELENBQWxELEVBQXFEdUMsTUFBckQ7UUFDQTs7TUFDRixLQUFLSSx5QkFBYUcsV0FBbEI7UUFDRXJELFdBQVcsR0FBRzVDLFFBQVEsQ0FBQzZDLGNBQVQsRUFBZDtRQUNBRCxXQUFXLENBQUNWLE1BQVosQ0FBbUJpQixLQUFLLEdBQUcsQ0FBM0IsRUFBOEIsQ0FBOUIsRUFBaUN1QyxNQUFqQztRQUNBOztNQUNGO1FBQ0U7SUFsQko7O0lBcUJBLEtBQUtnQix1QkFBTCxDQUE2QjFHLFFBQTdCLEVBQXVDNEMsV0FBdkM7SUFDQSxJQUFNOEcsS0FBSyxHQUFHLEtBQUsvTSxNQUFuQjtJQUNBK00sS0FBSyxDQUFDdkgsTUFBTixDQUFhVyxXQUFiO0lBQ0EsS0FBSzZHLHFCQUFMLENBQTJCM0osUUFBM0IsRUFBcUNtRCxLQUFyQyxFQUE0Q0QsS0FBNUMsRUFBbUQsQ0FBbkQ7SUFFQTs7SUFDQSxJQUFNMEcsY0FBYyxHQUFHO01BQ3JCM0ksT0FBTyxFQUFFLENBQUNBLE9BQU8sQ0FBQyxDQUFELENBQVIsRUFBYXlFLE1BQWIsQ0FEWTtNQUVyQjNGLE9BQU8sRUFBRUEsT0FGWTtNQUdyQkMsUUFBUSxFQUFFQSxRQUhXO01BSXJCa0QsS0FBSyxFQUFFQSxLQUpjO01BS3JCQyxLQUFLLEVBQUVBO0lBTGMsQ0FBdkI7SUFRQXVHLEtBQUssQ0FBQzNHLE1BQU4sQ0FBYSw0QkFBZTZHLGNBQWMsQ0FBQzNJLE9BQTlCLENBQWIsRUFBcUQySSxjQUFyRDtJQUNBLEtBQUsxTSxhQUFMLENBQW1CbUUsSUFBbkIsQ0FBd0IsQ0FBQ3VJLGNBQUQsRUFBaUIsQ0FBakIsQ0FBeEI7SUFFQTs7SUFDQSxJQUFNQyxlQUFlLEdBQUc7TUFDdEI1SSxPQUFPLEVBQUUsQ0FBQ3lFLE1BQUQsRUFBU3pFLE9BQU8sQ0FBQyxDQUFELENBQWhCLENBRGE7TUFFdEJsQixPQUFPLEVBQUVBLE9BRmE7TUFHdEJDLFFBQVEsRUFBRUEsUUFIWTtNQUl0QmtELEtBQUssRUFBRUEsS0FKZTtNQUt0QkMsS0FBSyxFQUFFQSxLQUFLLEdBQUc7SUFMTyxDQUF4QjtJQVFBdUcsS0FBSyxDQUFDM0csTUFBTixDQUFhLDRCQUFlOEcsZUFBZSxDQUFDNUksT0FBL0IsQ0FBYixFQUFzRDRJLGVBQXREO0lBQ0EsS0FBSzNNLGFBQUwsQ0FBbUJtRSxJQUFuQixDQUF3QixDQUFDd0ksZUFBRCxFQUFrQixDQUFsQixDQUF4QjtJQUNBLEtBQUtwTixzQkFBTCxHQUE4QixJQUE5QjtFQUNELENBOUREO0VBZ0VBOzs7Ozs7O0VBS0FxRDtJQUNFLElBQ0UsS0FBS0osaUJBQUwsSUFDQSxLQUFLQSxpQkFBTCxDQUF1QjFFLElBQXZCLElBQStCa0ssZ0NBQW9CNEUsV0FGckQsRUFHRTtNQUNBLElBQU1uSixHQUFHLEdBQUcsS0FBS2pCLGlCQUFqQjtNQUNBLEtBQUsrRixtQkFBTCxDQUF5QjlFLEdBQXpCLEVBQThCLEtBQUt6RCxhQUFuQztNQUNBLElBQU02TSxPQUFPLEdBQUcsS0FBS0MsYUFBTCxFQUFoQjs7TUFDQSxJQUFJLEtBQUt0TixzQkFBVCxFQUFpQztRQUMvQixLQUFLNkUsYUFBTCxDQUNFLElBQUlDLFdBQUosQ0FDRTVHLGVBQWUsQ0FBQ0UsU0FEbEIsRUFFRSxLQUFLNEIsc0JBRlAsRUFHRWlFLEdBSEYsQ0FERjtNQU9EOztNQUVELEtBQUtqRSxzQkFBTCxHQUE4QixJQUE5QjtNQUNBLE9BQU9xTixPQUFQO0lBQ0Q7O0lBQ0QsT0FBTyxLQUFQO0VBQ0QsQ0F0QkQ7RUF3QkE7Ozs7Ozs7RUFLQWpLO0lBQ0UsSUFBTW1LLFlBQVksR0FBRyxLQUFLL00sYUFBMUI7SUFDQSxJQUFNZ04saUJBQWlCLEdBQUcsRUFBMUI7SUFDQSxJQUFJQyxPQUFPLEdBQUcsS0FBZDtJQUNBLElBQUlDLFNBQUosRUFBZXhILFdBQWYsRUFBNEJnRCxXQUE1QixFQUF5QzVGLFFBQXpDLEVBQW1EYyxDQUFuRCxFQUFzRHFDLEtBQXRELEVBQTZEa0gsSUFBN0Q7SUFDQSxJQUFJQyxRQUFKLEVBQWNDLEtBQWQsRUFBcUJ6SCxXQUFyQixFQUFrQ3dFLEdBQWxDOztJQUNBLEtBQUt4RyxDQUFDLEdBQUdtSixZQUFZLENBQUNqSixNQUFiLEdBQXNCLENBQS9CLEVBQWtDRixDQUFDLElBQUksQ0FBdkMsRUFBMEMsRUFBRUEsQ0FBNUMsRUFBK0M7TUFDN0M4RSxXQUFXLEdBQUdxRSxZQUFZLENBQUNuSixDQUFELENBQTFCO01BQ0FnQyxXQUFXLEdBQUc4QyxXQUFXLENBQUMsQ0FBRCxDQUF6QjtNQUNBMEIsR0FBRyxHQUFHLGtCQUFPeEUsV0FBVyxDQUFDL0MsT0FBbkIsQ0FBTjs7TUFDQSxJQUFJK0MsV0FBVyxDQUFDSSxLQUFoQixFQUF1QjtRQUNyQjtRQUNBb0UsR0FBRyxJQUFJLE1BQU14RSxXQUFXLENBQUNJLEtBQVosQ0FBa0JxRSxJQUFsQixDQUF1QixHQUF2QixDQUFiO01BQ0Q7O01BQ0QsSUFBSSxFQUFFRCxHQUFHLElBQUk0QyxpQkFBVCxDQUFKLEVBQWlDO1FBQy9CQSxpQkFBaUIsQ0FBQzVDLEdBQUQsQ0FBakIsR0FBeUIsRUFBekI7TUFDRDs7TUFDRCxJQUFJMUIsV0FBVyxDQUFDLENBQUQsQ0FBWCxLQUFtQixDQUF2QixFQUEwQjtRQUN4QnNFLGlCQUFpQixDQUFDNUMsR0FBRCxDQUFqQixDQUF1QmlELEtBQXZCLEdBQStCekgsV0FBL0I7UUFDQW9ILGlCQUFpQixDQUFDNUMsR0FBRCxDQUFqQixDQUF1Qm5FLEtBQXZCLEdBQStCTCxXQUFXLENBQUNLLEtBQTNDO01BQ0QsQ0FIRCxNQUdPLElBQUl5QyxXQUFXLENBQUMsQ0FBRCxDQUFYLElBQWtCLENBQXRCLEVBQXlCO1FBQzlCc0UsaUJBQWlCLENBQUM1QyxHQUFELENBQWpCLENBQXVCK0MsSUFBdkIsR0FBOEJ2SCxXQUE5QjtRQUNBb0gsaUJBQWlCLENBQUM1QyxHQUFELENBQWpCLENBQXVCbkUsS0FBdkIsR0FBK0JMLFdBQVcsQ0FBQ0ssS0FBWixHQUFvQixDQUFuRDtNQUNEO0lBQ0Y7O0lBQ0QsS0FBS21FLEdBQUwsSUFBWTRDLGlCQUFaLEVBQStCO01BQzdCSyxLQUFLLEdBQUdMLGlCQUFpQixDQUFDNUMsR0FBRCxDQUFqQixDQUF1QmlELEtBQS9CO01BQ0FGLElBQUksR0FBR0gsaUJBQWlCLENBQUM1QyxHQUFELENBQWpCLENBQXVCK0MsSUFBOUI7TUFDQWxILEtBQUssR0FBRytHLGlCQUFpQixDQUFDNUMsR0FBRCxDQUFqQixDQUF1Qm5FLEtBQS9CO01BQ0FtSCxRQUFRLEdBQUduSCxLQUFLLEdBQUcsQ0FBbkI7O01BQ0EsSUFBSWtILElBQUksS0FBS3ROLFNBQWIsRUFBd0I7UUFDdEIrRixXQUFXLEdBQUd1SCxJQUFkO01BQ0QsQ0FGRCxNQUVPO1FBQ0x2SCxXQUFXLEdBQUd5SCxLQUFkO01BQ0Q7O01BQ0QsSUFBSUQsUUFBUSxHQUFHLENBQWYsRUFBa0I7UUFDaEJBLFFBQVEsR0FBRyxDQUFYO01BQ0Q7O01BQ0R0SyxRQUFRLEdBQUc4QyxXQUFXLENBQUM5QyxRQUF2QjtNQUNBNEMsV0FBVyxHQUFHNUMsUUFBUSxDQUFDNkMsY0FBVCxFQUFkO01BQ0F1SCxTQUFTLEdBQUd4SCxXQUFaO01BQ0F1SCxPQUFPLEdBQUcsS0FBVjs7TUFDQSxRQUFRbkssUUFBUSxDQUFDRyxPQUFULEVBQVI7UUFDRSxLQUFLMkYseUJBQWFJLGlCQUFsQjtVQUNFLElBQUl0RCxXQUFXLENBQUNFLFdBQVcsQ0FBQ0ksS0FBWixDQUFrQixDQUFsQixDQUFELENBQVgsQ0FBa0NsQyxNQUFsQyxHQUEyQyxDQUEvQyxFQUFrRDtZQUNoRDRCLFdBQVcsQ0FBQ0UsV0FBVyxDQUFDSSxLQUFaLENBQWtCLENBQWxCLENBQUQsQ0FBWCxDQUFrQ2hCLE1BQWxDLENBQXlDaUIsS0FBekMsRUFBZ0QsQ0FBaEQ7WUFDQWdILE9BQU8sR0FBRyxJQUFWO1VBQ0Q7O1VBQ0Q7O1FBQ0YsS0FBS3JFLHlCQUFhRyxXQUFsQjtVQUNFLElBQUlyRCxXQUFXLENBQUM1QixNQUFaLEdBQXFCLENBQXpCLEVBQTRCO1lBQzFCNEIsV0FBVyxDQUFDVixNQUFaLENBQW1CaUIsS0FBbkIsRUFBMEIsQ0FBMUI7WUFDQWdILE9BQU8sR0FBRyxJQUFWO1VBQ0Q7O1VBQ0Q7O1FBQ0YsS0FBS3JFLHlCQUFhTSxhQUFsQjtVQUNFZ0UsU0FBUyxHQUFHQSxTQUFTLENBQUN0SCxXQUFXLENBQUNJLEtBQVosQ0FBa0IsQ0FBbEIsQ0FBRCxDQUFyQjs7UUFDRjs7UUFDQSxLQUFLNEMseUJBQWFLLE9BQWxCO1VBQ0VpRSxTQUFTLEdBQUdBLFNBQVMsQ0FBQ3RILFdBQVcsQ0FBQ0ksS0FBWixDQUFrQixDQUFsQixDQUFELENBQXJCOztVQUNBLElBQUlrSCxTQUFTLENBQUNwSixNQUFWLEdBQW1CLENBQXZCLEVBQTBCO1lBQ3hCLElBQUltQyxLQUFLLElBQUlpSCxTQUFTLENBQUNwSixNQUFWLEdBQW1CLENBQWhDLEVBQW1DO2NBQ2pDbUMsS0FBSyxHQUFHLENBQVI7WUFDRDs7WUFDRGlILFNBQVMsQ0FBQ2xJLE1BQVYsQ0FBaUJpQixLQUFqQixFQUF3QixDQUF4QjtZQUNBZ0gsT0FBTyxHQUFHLElBQVY7O1lBQ0EsSUFBSWhILEtBQUssS0FBSyxDQUFkLEVBQWlCO2NBQ2Y7Y0FDQWlILFNBQVMsQ0FBQ0ksR0FBVjtjQUNBSixTQUFTLENBQUMvSSxJQUFWLENBQWUrSSxTQUFTLENBQUMsQ0FBRCxDQUF4QjtjQUNBRSxRQUFRLEdBQUdGLFNBQVMsQ0FBQ3BKLE1BQVYsR0FBbUIsQ0FBOUI7WUFDRDtVQUNGOztVQUNEOztRQUNGLFFBaENGLENBaUNFOztNQWpDRjs7TUFvQ0EsSUFBSW1KLE9BQUosRUFBYTtRQUNYLEtBQUt6RCx1QkFBTCxDQUE2QjFHLFFBQTdCLEVBQXVDNEMsV0FBdkM7UUFDQSxJQUFNaEMsUUFBUSxHQUFHLEVBQWpCOztRQUNBLElBQUl5SixJQUFJLEtBQUt0TixTQUFiLEVBQXdCO1VBQ3RCLEtBQUtKLE1BQUwsQ0FBWXdGLE1BQVosQ0FBbUJrSSxJQUFuQjtVQUNBekosUUFBUSxDQUFDUyxJQUFULENBQWNnSixJQUFJLENBQUNwSixPQUFMLENBQWEsQ0FBYixDQUFkO1FBQ0Q7O1FBQ0QsSUFBSXNKLEtBQUssS0FBS3hOLFNBQWQsRUFBeUI7VUFDdkIsS0FBS0osTUFBTCxDQUFZd0YsTUFBWixDQUFtQm9JLEtBQW5CO1VBQ0EzSixRQUFRLENBQUNTLElBQVQsQ0FBY2tKLEtBQUssQ0FBQ3RKLE9BQU4sQ0FBYyxDQUFkLENBQWQ7UUFDRDs7UUFDRCxJQUFJb0osSUFBSSxLQUFLdE4sU0FBVCxJQUFzQndOLEtBQUssS0FBS3hOLFNBQXBDLEVBQStDO1VBQzdDO1VBQ0EsSUFBTTZNLGNBQWMsR0FBRztZQUNyQjFHLEtBQUssRUFBRUosV0FBVyxDQUFDSSxLQURFO1lBRXJCbkQsT0FBTyxFQUFFK0MsV0FBVyxDQUFDL0MsT0FGQTtZQUdyQkMsUUFBUSxFQUFFOEMsV0FBVyxDQUFDOUMsUUFIRDtZQUlyQm1ELEtBQUssRUFBRW1ILFFBSmM7WUFLckJySixPQUFPLEVBQUVMO1VBTFksQ0FBdkI7VUFRQSxLQUFLakUsTUFBTCxDQUFZb0csTUFBWixDQUNFLDRCQUFlNkcsY0FBYyxDQUFDM0ksT0FBOUIsQ0FERixFQUVFMkksY0FGRjtRQUlEOztRQUNELEtBQUtELHFCQUFMLENBQTJCM0osUUFBM0IsRUFBcUNtRCxLQUFyQyxFQUE0Q0wsV0FBVyxDQUFDSSxLQUF4RCxFQUErRCxDQUFDLENBQWhFOztRQUNBLElBQUksS0FBSzVHLGNBQVQsRUFBeUI7VUFDdkIsS0FBS2EsUUFBTCxDQUFjdUUsU0FBZCxHQUEwQkMsYUFBMUIsQ0FBd0MsS0FBS3JGLGNBQTdDO1VBQ0EsS0FBS0EsY0FBTCxHQUFzQixJQUF0QjtRQUNEOztRQUNEMk4sWUFBWSxDQUFDakosTUFBYixHQUFzQixDQUF0QjtNQUNEO0lBQ0Y7O0lBQ0QsT0FBT21KLE9BQVA7RUFDRCxDQWpIRDtFQW1IQTs7Ozs7OztFQUtBcksscURBQXdCRSxRQUF4QixFQUFrQzRDLFdBQWxDLEVBQTZDO0lBQzNDLEtBQUszRixnQkFBTCxHQUF3QixJQUF4QjtJQUNBK0MsUUFBUSxDQUFDNkUsY0FBVCxDQUF3QmpDLFdBQXhCO0lBQ0EsS0FBSzNGLGdCQUFMLEdBQXdCLEtBQXhCO0VBQ0QsQ0FKRDtFQU1BOzs7Ozs7Ozs7RUFPQTZDLG1EQUFzQkUsUUFBdEIsRUFBZ0NtRCxLQUFoQyxFQUF1Q0QsS0FBdkMsRUFBOEN1SCxLQUE5QyxFQUFtRDtJQUNqRCxLQUFLOU4sTUFBTCxDQUFZK04sZUFBWixDQUNFMUssUUFBUSxDQUFDZ0QsU0FBVCxFQURGLEVBRUUsVUFBVXFFLGdCQUFWLEVBQTBCO01BQ3hCLElBQ0VBLGdCQUFnQixDQUFDckgsUUFBakIsS0FBOEJBLFFBQTlCLEtBQ0NrRCxLQUFLLEtBQUtuRyxTQUFWLElBQ0NzSyxnQkFBZ0IsQ0FBQ25FLEtBQWpCLEtBQTJCbkcsU0FENUIsSUFFQyxtQkFBT3NLLGdCQUFnQixDQUFDbkUsS0FBeEIsRUFBK0JBLEtBQS9CLENBSEYsS0FJQW1FLGdCQUFnQixDQUFDbEUsS0FBakIsR0FBeUJBLEtBTDNCLEVBTUU7UUFDQWtFLGdCQUFnQixDQUFDbEUsS0FBakIsSUFBMEJzSCxLQUExQjtNQUNEO0lBQ0YsQ0FaSDtFQWNELENBZkQ7O0VBZ0JGO0FBQUMsQ0F2ekNELENBQXFCRSxtQkFBckI7QUF5ekNBOzs7Ozs7O0FBS0EsU0FBU3ZELGNBQVQsQ0FBd0JZLENBQXhCLEVBQTJCQyxDQUEzQixFQUE0QjtFQUMxQixPQUFPRCxDQUFDLENBQUM3RSxLQUFGLEdBQVU4RSxDQUFDLENBQUM5RSxLQUFuQjtBQUNEO0FBRUQ7Ozs7Ozs7Ozs7OztBQVVBLFNBQVMrRSxxQ0FBVCxDQUNFMEMsZ0JBREYsRUFFRTlILFdBRkYsRUFHRW1CLFVBSEYsRUFHWTtFQUVWLElBQU1qRSxRQUFRLEdBQUc4QyxXQUFXLENBQUM5QyxRQUE3Qjs7RUFFQSxJQUFJQSxRQUFRLENBQUNHLE9BQVQsT0FBdUIyRix5QkFBYU8sTUFBeEMsRUFBZ0Q7SUFDOUMsSUFBSXRDLGNBQWM7SUFBRztJQUNuQi9ELFFBREY7O0lBSUEsSUFBSThDLFdBQVcsQ0FBQ0ssS0FBWixLQUFzQjFJLDBCQUExQixFQUFzRDtNQUNwRCxJQUFNdUosY0FBYyxHQUFHLDhCQUF2Qjs7TUFDQSxJQUFJQSxjQUFKLEVBQW9CO1FBQ2xCRCxjQUFjO1FBQUc7UUFDZkEsY0FBYyxDQUFDSyxLQUFmLEdBQXVCQyxTQUF2QixDQUFpQ0wsY0FBakMsRUFBaURDLFVBQWpELENBREY7TUFHRDs7TUFDRCxJQUFNNEcsdUJBQXVCLEdBQUcsaUNBQzlCOUcsY0FBYyxDQUFDSixTQUFmLEVBRDhCLEVBRTlCLDhCQUFtQmlILGdCQUFuQixFQUFxQzNHLFVBQXJDLENBRjhCLENBQWhDO01BSUEsSUFBTTZHLHVCQUF1QixHQUMzQnhCLElBQUksQ0FBQ0MsSUFBTCxDQUFVc0IsdUJBQVYsSUFBcUM5RyxjQUFjLENBQUMwQyxTQUFmLEVBRHZDO01BRUEsT0FBT3FFLHVCQUF1QixHQUFHQSx1QkFBakM7SUFDRDtFQUNGOztFQUVELElBQU1uRixVQUFVLEdBQUcsOEJBQW1CaUYsZ0JBQW5CLEVBQXFDM0csVUFBckMsQ0FBbkI7RUFDQXRKLFdBQVcsQ0FBQyxDQUFELENBQVgsR0FBaUIsOEJBQW1CbUksV0FBVyxDQUFDN0IsT0FBWixDQUFvQixDQUFwQixDQUFuQixFQUEyQ2dELFVBQTNDLENBQWpCO0VBQ0F0SixXQUFXLENBQUMsQ0FBRCxDQUFYLEdBQWlCLDhCQUFtQm1JLFdBQVcsQ0FBQzdCLE9BQVosQ0FBb0IsQ0FBcEIsQ0FBbkIsRUFBMkNnRCxVQUEzQyxDQUFqQjtFQUNBLE9BQU8sMENBQXlCMEIsVUFBekIsRUFBcUNoTCxXQUFyQyxDQUFQO0FBQ0Q7QUFFRDs7Ozs7Ozs7Ozs7O0FBVUEsU0FBUytNLG9CQUFULENBQThCa0QsZ0JBQTlCLEVBQWdEOUgsV0FBaEQsRUFBNkRtQixVQUE3RCxFQUF1RTtFQUNyRSxJQUFNakUsUUFBUSxHQUFHOEMsV0FBVyxDQUFDOUMsUUFBN0I7O0VBRUEsSUFDRUEsUUFBUSxDQUFDRyxPQUFULE9BQXVCMkYseUJBQWFPLE1BQXBDLElBQ0F2RCxXQUFXLENBQUNLLEtBQVosS0FBc0IxSSwwQkFGeEIsRUFHRTtJQUNBLElBQUlzSixjQUFjO0lBQUc7SUFDbkIvRCxRQURGO0lBR0EsSUFBTWdFLGNBQWMsR0FBRyw4QkFBdkI7O0lBQ0EsSUFBSUEsY0FBSixFQUFvQjtNQUNsQkQsY0FBYztNQUFHO01BQ2ZBLGNBQWMsQ0FBQ0ssS0FBZixHQUF1QkMsU0FBdkIsQ0FBaUNMLGNBQWpDLEVBQWlEQyxVQUFqRCxDQURGO0lBR0Q7O0lBQ0QsT0FBTyw0QkFDTEYsY0FBYyxDQUFDZ0gsZUFBZixDQUNFLDhCQUFtQkgsZ0JBQW5CLEVBQXFDM0csVUFBckMsQ0FERixDQURLLEVBSUxBLFVBSkssQ0FBUDtFQU1EOztFQUNELElBQU0wQixVQUFVLEdBQUcsOEJBQW1CaUYsZ0JBQW5CLEVBQXFDM0csVUFBckMsQ0FBbkI7RUFDQXRKLFdBQVcsQ0FBQyxDQUFELENBQVgsR0FBaUIsOEJBQW1CbUksV0FBVyxDQUFDN0IsT0FBWixDQUFvQixDQUFwQixDQUFuQixFQUEyQ2dELFVBQTNDLENBQWpCO0VBQ0F0SixXQUFXLENBQUMsQ0FBRCxDQUFYLEdBQWlCLDhCQUFtQm1JLFdBQVcsQ0FBQzdCLE9BQVosQ0FBb0IsQ0FBcEIsQ0FBbkIsRUFBMkNnRCxVQUEzQyxDQUFqQjtFQUNBLE9BQU8sNEJBQ0wsa0NBQWlCMEIsVUFBakIsRUFBNkJoTCxXQUE3QixDQURLLEVBRUxzSixVQUZLLENBQVA7QUFJRDtBQUVEOzs7OztBQUdBLFNBQVN2Ryx1QkFBVCxHQUFnQztFQUM5QixJQUFNRCxLQUFLLEdBQUcsZ0NBQWQ7RUFDQSxPQUFPLFVBQVVzQyxPQUFWLEVBQW1CaUwsVUFBbkIsRUFBNkI7SUFDbEMsT0FBT3ZOLEtBQUssQ0FBQ3FJLHlCQUFhQyxLQUFkLENBQVo7RUFDRCxDQUZEO0FBR0Q7O2VBRWNqRyxNIiwibmFtZXMiOlsiQ0lSQ0xFX0NFTlRFUl9JTkRFWCIsIkNJUkNMRV9DSVJDVU1GRVJFTkNFX0lOREVYIiwidGVtcEV4dGVudCIsInRlbXBTZWdtZW50IiwiTW9kaWZ5RXZlbnRUeXBlIiwiTU9ESUZZU1RBUlQiLCJNT0RJRllFTkQiLCJfX2V4dGVuZHMiLCJ0eXBlIiwiZmVhdHVyZXMiLCJtYXBCcm93c2VyRXZlbnQiLCJfc3VwZXIiLCJfdGhpcyIsIkV2ZW50Iiwib3B0aW9ucyIsIm9uIiwib25jZSIsInVuIiwiYm91bmRIYW5kbGVGZWF0dXJlQ2hhbmdlXyIsImhhbmRsZUZlYXR1cmVDaGFuZ2VfIiwiYmluZCIsImNvbmRpdGlvbl8iLCJjb25kaXRpb24iLCJwcmltYXJ5QWN0aW9uIiwiZGVmYXVsdERlbGV0ZUNvbmRpdGlvbl8iLCJkZWxldGVDb25kaXRpb25fIiwiZGVsZXRlQ29uZGl0aW9uIiwiaW5zZXJ0VmVydGV4Q29uZGl0aW9uXyIsImluc2VydFZlcnRleENvbmRpdGlvbiIsImFsd2F5cyIsInZlcnRleEZlYXR1cmVfIiwidmVydGV4U2VnbWVudHNfIiwibGFzdFBpeGVsXyIsImlnbm9yZU5leHRTaW5nbGVDbGlja18iLCJmZWF0dXJlc0JlaW5nTW9kaWZpZWRfIiwickJ1c2hfIiwiUkJ1c2giLCJwaXhlbFRvbGVyYW5jZV8iLCJwaXhlbFRvbGVyYW5jZSIsInVuZGVmaW5lZCIsInNuYXBwZWRUb1ZlcnRleF8iLCJjaGFuZ2luZ0ZlYXR1cmVfIiwiZHJhZ1NlZ21lbnRzXyIsIm92ZXJsYXlfIiwiVmVjdG9yTGF5ZXIiLCJzb3VyY2UiLCJWZWN0b3JTb3VyY2UiLCJ1c2VTcGF0aWFsSW5kZXgiLCJ3cmFwWCIsInN0eWxlIiwiZ2V0RGVmYXVsdFN0eWxlRnVuY3Rpb24iLCJ1cGRhdGVXaGlsZUFuaW1hdGluZyIsInVwZGF0ZVdoaWxlSW50ZXJhY3RpbmciLCJTRUdNRU5UX1dSSVRFUlNfIiwid3JpdGVQb2ludEdlb21ldHJ5XyIsIndyaXRlTGluZVN0cmluZ0dlb21ldHJ5XyIsIndyaXRlUG9seWdvbkdlb21ldHJ5XyIsIndyaXRlTXVsdGlQb2ludEdlb21ldHJ5XyIsIndyaXRlTXVsdGlMaW5lU3RyaW5nR2VvbWV0cnlfIiwid3JpdGVNdWx0aVBvbHlnb25HZW9tZXRyeV8iLCJ3cml0ZUNpcmNsZUdlb21ldHJ5XyIsIndyaXRlR2VvbWV0cnlDb2xsZWN0aW9uR2VvbWV0cnlfIiwic291cmNlXyIsImhpdERldGVjdGlvbl8iLCJDb2xsZWN0aW9uIiwiZ2V0RmVhdHVyZXMiLCJhZGRFdmVudExpc3RlbmVyIiwiVmVjdG9yRXZlbnRUeXBlIiwiQURERkVBVFVSRSIsImhhbmRsZVNvdXJjZUFkZF8iLCJSRU1PVkVGRUFUVVJFIiwiaGFuZGxlU291cmNlUmVtb3ZlXyIsIkVycm9yIiwiaGl0RGV0ZWN0aW9uIiwiZmVhdHVyZXNfIiwiZm9yRWFjaCIsImFkZEZlYXR1cmVfIiwiQ29sbGVjdGlvbkV2ZW50VHlwZSIsIkFERCIsImhhbmRsZUZlYXR1cmVBZGRfIiwiUkVNT1ZFIiwiaGFuZGxlRmVhdHVyZVJlbW92ZV8iLCJsYXN0UG9pbnRlckV2ZW50XyIsImRlbHRhXyIsInNuYXBUb1BvaW50ZXJfIiwic25hcFRvUG9pbnRlciIsIk1vZGlmeSIsImZlYXR1cmUiLCJnZW9tZXRyeSIsImdldEdlb21ldHJ5Iiwid3JpdGVyIiwiZ2V0VHlwZSIsIm1hcCIsImdldE1hcCIsImlzUmVuZGVyZWQiLCJnZXRBY3RpdmUiLCJoYW5kbGVQb2ludGVyQXRQaXhlbF8iLCJFdmVudFR5cGUiLCJDSEFOR0UiLCJldnQiLCJzZWdtZW50cyIsImdldEFycmF5IiwiaSIsImlpIiwibGVuZ3RoIiwic2VnbWVudCIsInMiLCJzcyIsImluZGV4T2YiLCJwdXNoIiwiZ2V0TGVuZ3RoIiwiZGlzcGF0Y2hFdmVudCIsIk1vZGlmeUV2ZW50IiwicmVtb3ZlRmVhdHVyZVNlZ21lbnREYXRhXyIsImdldFNvdXJjZSIsInJlbW92ZUZlYXR1cmUiLCJyZW1vdmVFdmVudExpc3RlbmVyIiwickJ1c2giLCJub2Rlc1RvUmVtb3ZlIiwibm9kZSIsIm5vZGVUb1JlbW92ZSIsImoiLCJzcGxpY2UiLCJyZW1vdmUiLCJhY3RpdmUiLCJzZXRBY3RpdmUiLCJjYWxsIiwic2V0TWFwIiwiZXZlbnQiLCJlbGVtZW50IiwidGFyZ2V0IiwicmVtb3ZlRmVhdHVyZV8iLCJjb29yZGluYXRlcyIsImdldENvb3JkaW5hdGVzIiwic2VnbWVudERhdGEiLCJpbnNlcnQiLCJnZXRFeHRlbnQiLCJwb2ludHMiLCJkZXB0aCIsImluZGV4Iiwic2xpY2UiLCJsaW5lcyIsImpqIiwicmluZ3MiLCJwb2x5Z29ucyIsImsiLCJrayIsImdldENlbnRlciIsImNlbnRlclNlZ21lbnREYXRhIiwiY2lyY3VtZmVyZW5jZVNlZ21lbnREYXRhIiwiZmVhdHVyZVNlZ21lbnRzIiwiY2lyY2xlR2VvbWV0cnkiLCJ1c2VyUHJvamVjdGlvbiIsInByb2plY3Rpb24iLCJnZXRWaWV3IiwiZ2V0UHJvamVjdGlvbiIsImNsb25lIiwidHJhbnNmb3JtIiwiZ2VvbWV0cmllcyIsImdldEdlb21ldHJpZXNBcnJheSIsImdlb21ldHJ5XzEiLCJ2ZXJ0ZXhGZWF0dXJlIiwiRmVhdHVyZSIsIlBvaW50IiwiYWRkRmVhdHVyZSIsInNldENvb3JkaW5hdGVzIiwic2V0Iiwib3JpZ2luYWxFdmVudCIsImhhbmRsZWQiLCJnZXRJbnRlcmFjdGluZyIsIk1hcEJyb3dzZXJFdmVudFR5cGUiLCJQT0lOVEVSTU9WRSIsImhhbmRsaW5nRG93blVwU2VxdWVuY2UiLCJoYW5kbGVQb2ludGVyTW92ZV8iLCJTSU5HTEVDTElDSyIsInJlbW92ZVBvaW50IiwiaGFuZGxlRXZlbnQiLCJ3aWxsTW9kaWZ5RmVhdHVyZXNfIiwidmVydGV4IiwiY29vcmRpbmF0ZSIsImRyYWdTZWdtZW50IiwiZ2V0U3RyaWRlIiwiR2VvbWV0cnlUeXBlIiwiUE9JTlQiLCJNVUxUSV9QT0lOVCIsIkxJTkVfU1RSSU5HIiwiTVVMVElfTElORV9TVFJJTkciLCJQT0xZR09OIiwiTVVMVElfUE9MWUdPTiIsIkNJUkNMRSIsInNldENlbnRlciIsInJhZGl1cyIsInNldFJhZGl1cyIsImdldFJhZGl1cyIsInNldEdlb21ldHJ5Q29vcmRpbmF0ZXNfIiwiY3JlYXRlT3JVcGRhdGVWZXJ0ZXhGZWF0dXJlXyIsInBpeGVsQ29vcmRpbmF0ZSIsInBpeGVsIiwiaW5zZXJ0VmVydGljZXMiLCJ2ZXJ0ZXhFeHRlbnQiLCJzZWdtZW50RGF0YU1hdGNoZXMiLCJnZXRJbkV4dGVudCIsImNvbXBvbmVudFNlZ21lbnRzIiwic29ydCIsImNvbXBhcmVJbmRleGVzIiwic2VnbWVudERhdGFNYXRjaCIsInVpZCIsImpvaW4iLCJBcnJheSIsImNsb3Nlc3RWZXJ0ZXgiLCJjbG9zZXN0T25TZWdtZW50RGF0YSIsImluc2VydFZlcnRleF8iLCJ1cGRhdGUiLCJvcHRfY29vcmRpbmF0ZSIsImdldENvb3JkaW5hdGVGcm9tUGl4ZWwiLCJzb3J0QnlEaXN0YW5jZSIsImEiLCJiIiwicHJvamVjdGVkRGlzdGFuY2VUb1NlZ21lbnREYXRhU3F1YXJlZCIsIm5vZGVzIiwiaGl0UG9pbnRHZW9tZXRyeSIsImxheWVyRmlsdGVyIiwibGF5ZXIiLCJmb3JFYWNoRmVhdHVyZUF0UGl4ZWwiLCJnZXRGbGF0Q29vcmRpbmF0ZXMiLCJ2aWV3RXh0ZW50IiwiYnVmZmVyIiwiZ2V0UmVzb2x1dGlvbiIsImJveCIsImNsb3Nlc3RTZWdtZW50IiwidmVydGV4UGl4ZWwiLCJnZXRQaXhlbEZyb21Db29yZGluYXRlIiwiZGlzdCIsInZlcnRleFNlZ21lbnRzIiwicGl4ZWwxIiwicGl4ZWwyIiwic3F1YXJlZERpc3QxIiwic3F1YXJlZERpc3QyIiwiTWF0aCIsInNxcnQiLCJtaW4iLCJnZW9tZXRyeVVpZCIsInJUcmVlIiwidXBkYXRlU2VnbWVudEluZGljZXNfIiwibmV3U2VnbWVudERhdGEiLCJuZXdTZWdtZW50RGF0YTIiLCJQT0lOVEVSRFJBRyIsInJlbW92ZWQiLCJyZW1vdmVWZXJ0ZXhfIiwiZHJhZ1NlZ21lbnRzIiwic2VnbWVudHNCeUZlYXR1cmUiLCJkZWxldGVkIiwiY29tcG9uZW50IiwibGVmdCIsIm5ld0luZGV4IiwicmlnaHQiLCJwb3AiLCJkZWx0YSIsImZvckVhY2hJbkV4dGVudCIsIlBvaW50ZXJJbnRlcmFjdGlvbiIsInBvaW50Q29vcmRpbmF0ZXMiLCJkaXN0YW5jZVRvQ2VudGVyU3F1YXJlZCIsImRpc3RhbmNlVG9DaXJjdW1mZXJlbmNlIiwiZ2V0Q2xvc2VzdFBvaW50IiwicmVzb2x1dGlvbiJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW50ZXJhY3Rpb24vTW9kaWZ5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19